/* eslint-disable @typescript-eslint/no-unused-vars */
import { type Creator, type Episode, type Show } from '../types'

import thePrimeTimeTerminalFamilyFeudEp1 from './thePrimeTime-terminal-family-feud-ep1.json'
import leetHeatS1E1 from './leet-heat-s1e1.json'
import leetHeatS1E2 from './leet-heat-s1e2.json'
import arcadePitGamingQuizTimeS1 from './arcade-pit-gaming-quiz-time-s1.json'
import dirtyLaundryS4E3 from './dirty-laundry-s4e3.json'
import hankschannelRealOrFakeE1 from './hankschannel-real-or-fake-e1.json'
import theBoardGameQuizShowS5E5 from './the-board-game-quiz-show-s5e5.json'
import theMcElroyFamilyClubHouse20250103 from './the-mcelroy-family-club-house-2025-01-03.json'
import gameShowdownS2E15 from './game-showdown-s2e15.json'
import gameShowdownS3E2 from './game-showdown-s3-e2.json'
import gameShowdownS3E3 from './game-showdown-s3-e3.json'
import gameShowdownS3E4 from './game-showdown-s3-e4.json'
import webDevGuessingGameSyntaxE1 from './web-dev-guessing-game-syntax-e1.json'
import fightingGameSoundTriviaHolidayMatsuri2024 from './fighting-game-sound-trivia-holiday-matsuri-2024.json'
import umActuallyS2E2 from './um-actually-s2e2.json'

export const creators: Record<string, Creator> = {
    Dropout: {
        name: 'Dropout',
        channelIcon:
            'https://yt3.googleusercontent.com/PGpRF6Ml4ldis47-zxBMtW9rl-gN-YKDk0BSYhvt5jwXahDS4rn6J-g1M5u55YqGBUnY2MERyg=s160-c-k-c0x00ffffff-no-rj',
        description: '',
        qrCode: 'https://www.dropout.tv/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@dropout'
            },
            social: {
                twitter: 'https://x.com/dropout'
            },
            support: {
                website: 'https://www.dropout.tv/'
            }
        }
    },
    MinnMax: {
        name: 'MinnMax',
        channelIcon:
            'https://yt3.googleusercontent.com/CAvDwFRsKjoGA9JLwwWqcSGsa5be42MGlsF_kiXPRFPt3NAAqe_BlsnK9xQz9EVH0HIBQygqAw=s160-c-k-c0x00ffffff-no-rj',
        description: '',
        qrCode: 'https://minnmax.com/',
        platforms: {
            content: {
                twitch: 'https://www.twitch.tv/minnmaxshow/',
                youtube: 'https://www.youtube.com/@minnmax'
            },
            social: {
                twitter: 'https://x.com/MinnMaxShow',
                bsky: 'minnmax.bsky.social'
            },
            support: {
                patreon: 'https://www.patreon.com/minnmax'
            }
        }
    },
    Smight: {
        name: 'Smight',
        channelIcon:
            'https://yt3.googleusercontent.com/2yNOmKlIbD36LXlbxccc_FeVuZpT6pYI8UV5jKHbmLPDNtIeT3e2Ph-rAybRgF8sRNFFI9PVCg=s160-c-k-c0x00ffffff-no-rj',
        description: '',
        qrCode: 'https://www.twitch.tv/smight',
        platforms: {
            content: {
                twitch: 'https://www.twitch.tv/smight'
            },
            social: {
                twitter: 'https://x.com/smight',
                bsky: 'smight.bsky.social'
            },
            support: {
                patreon: 'https://www.patreon.com/smight'
            }
        }
    },
    ThePrimeTime: {
        name: 'The Prime Time',
        channelIcon: 'https://yt3.googleusercontent.com/ytc/AIdro_k7J8-LWCa5QLDnY3x9kaArgJoSSMory4hgkYSBOFgvEg=s160-c-k-c0x00ffffff-no-rj',
        description: 'This is a place for all the things that are awesome on stream. ',
        qrCode: 'https://linktr.ee/ThePrimeagen',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@theprimetime',
                twitch: 'https://www.twitch.tv/theprimetimeagen',
                tiktok: 'https://www.tiktok.com/@theprimetimeagen'

            },
            social: {
                twitter: 'https://x.com/theprimetimeagen',
                bsky: 'theprimetimeagen.bsky.social',
                discord: 'https://discord.com/invite/ThePrimeagen'
            }
        }
    },
    LearnWithJason: {
        name: 'Learn With Jason',
        channelIcon: 'https://yt3.googleusercontent.com/Ghvu4wHclihg9GWWeOoaqa8owm1xHDVNse8U2JQwKf1wVbW-ygU1OyqzyVrpNYXwQSBeSvBKHgA=s160-c-k-c0x00ffffff-no-rj',
        description: 'Learn web dev with your friend Jason! Live pair programming with expert web devs, career advice, and coding tutorials. Get better at HTML, CSS, JavaScript, and the tools and frameworks built on top of them — join the LWJ community to find your people and learn, build, and grow together!',
        qrCode: 'https://www.learnwithjason.dev/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@learnwithjason'

            },
            social: {
                twitter: 'https://x.com/jlengstorf',
                bsky: 'https://bsky.app/profile/jason.energy',
                discord: 'https://discord.com/invite/lwj'
            }
        }
    },
    HankChannel: {
        name: 'HankChannel',
        description: '',
        channelIcon: 'https://yt3.ggpht.com/xaj75tqnNhHJVs9oqE69u5WnBfRe-9OcvtmcguuqVggsmoEHfYU6elwCJhKsM-sl1YyRYZEKTj8=s240-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://hankgreen.com/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@hankschannel'

            },
            social: {

            }
        }
    },
    GoingAnalog: {
        name: 'Going Analog',
        description: '',
        draft: true,
        channelIcon: 'https://yt3.googleusercontent.com/ytc/AIdro_kjmqXeW7uSZ0V4PU51N8q706HFrhq6RWwTBwX9ITHdy7k=s160-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://www.goinganalogshow.com/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@GoingAnalogShow'
            }
        }
    },
    TheMcElroyFamily: {
        name: 'The McElroy Family',
        description: '',
        channelIcon: 'https://yt3.ggpht.com/ytc/AIdro_l9S4VRObOQLRybvQ-yGHv9JQ0X0tykmF29I5giPGPKNA=s240-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://www.themcelroy.family/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@TheMcElroyFamily'
            }
        }
    },
    KindaFunnyGames: {
        name: 'Kinda Funny Games',
        description: '',
        channelIcon: 'https://yt3.ggpht.com/axzTphozq_1Nj3kqHVfWWU-Jby0VhwzRkne0JjnF8eV0lmWv5dyvej0_z6qhFR5Fy3Vqd8cq3g=s240-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://www.kindafunny.com/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@KindaFunnyGames'
            }
        }
    },
    Syntax: {
        name: 'Syntax',
        description: '',
        channelIcon: 'https://yt3.ggpht.com/gvvHQOWCRiNehiIKqDNS59DapvDsXsZugPnNqWumcp9OYCZPdmPTQw0AGaFEOb0uUKEg7VNpkA=s240-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://syntax.fm/',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@syntaxfm'
            }
        }
    },
    WoolieVSTheAlgorithm: {
        name: 'Woolie VS The Algorithm',
        description: '',
        channelIcon: 'https://yt3.ggpht.com/R7f87lgTyUGoJswzM1_omXA-fxxDiWm6sQBZBtX9yEJCOi_tcAbByFwVfahMdZdOec6d6Je0=s240-c-k-c0x00ffffff-no-rj',
        qrCode: 'https://linktr.ee/wooliewoolz',
        platforms: {
            content: {
                youtube: 'https://www.youtube.com/@woolievsthealgorithm'
            }
        }
    }
}

export const shows: Record<string, Show> = {
    'Um Actually': {
        name: 'Um Actually',
        description: 'Introducing a game show of fandom minutiae one-upmanship!',
        thumbnail: '/assets/images/playalong/um-actually.jpg',
        creator: creators.Dropout,
        episodes: [
            'um-actually-s2e2',
            'um-actually-s2e19',
            'um-actually-s5e23',
            'um-actually-s2e1',
            'um-actually-s1e5'
        ]
    },
    'Dirty Laundry': {
        name: 'Dirty Laundry',
        description:
            'Four guests tell secrets, guess who they belong to, and enjoy a few drinks.',
        thumbnail: '/assets/images/playalong/dirty-laundry.jpg',
        creator: creators.Dropout,
        episodes: ['dirty-laundry-s4e3', 'dirty-laundry-s2e1', 'dirty-laundry-s1e1']
    },
    'Arcade Pit': {
        name: 'Arcade Pit',
        description:
            'Arcade Pit is a 2v2 retro game show hosted every Sunday night (8 Eastern).',
        thumbnail: '/assets/images/playalong/arcade-pit.jpg',
        creator: creators.Smight,
        episodes: ['arcade-pit-gaming-quiz-time-s1', 'arcade-pit-halloween-2024', 'arcade-pit-giant-bomb-e13']
    },
    'Trivia Tower': {
        name: 'Trivia Tower',
        description:
            'Trivia Tower is a game show where contestants answer questions to climb the tower.',
        thumbnail: '/assets/images/playalong/trivia-tower.jpg',
        creator: creators.MinnMax,
        episodes: ['trivia-tower-e1']
    },
    'Terminal Feud': {
        name: 'Terminal Feud',
        description: 'Utilson vs Reactly',
        thumbnail: '/assets/images/playalong/terminal-family-feud.jpg',
        creator: creators.ThePrimeTime,
        episodes: ['thePrimeTime-terminal-family-feud-ep1']
    },
    'Leet Heat': {
        name: 'Leet Heat',
        description: 'A Game Show for Web Developers',
        thumbnail: '/assets/images/playalong/leet-heat.jpg',
        creator: creators.LearnWithJason,
        episodes: ['leet-heat-s1e2', 'leet-heat-s1e1']
    },
    'Real or Fake Hank Tweets': {
        name: 'Real or Fake Hank Tweets',
        description: '',
        thumbnail: '/assets/images/playalong/real-or-fake-hank-tweets.jpg',
        creator: creators.HankChannel,
        episodes: ['hankschannel-real-or-fake-e1']
    },
    'The Board Game Quiz Show': {
        name: 'The Board Game Quiz Show',
        description: '',
        draft: true,
        thumbnail: '/assets/images/playalong/the-board-game-quiz-show.jpg',
        creator: creators.GoingAnalog,
        episodes: ['the-board-game-quiz-show-s5e5']
    },
    'The McElroy Family Clubhouse': {
        name: 'The McElroy Family Clubhouse',
        description: '',
        thumbnail: '/assets/images/playalong/the-mcelroy-family-clubhouse.jpg',
        creator: creators.TheMcElroyFamily,
        episodes: ['the-mcelroy-family-club-house-2025-01-03']
    },
    'Game Showdown': {
        name: 'Game Showdown',
        description: '',
        thumbnail: '/assets/images/playalong/game-showdown.jpg',
        creator: creators.KindaFunnyGames,
        episodes: ['game-showdown-s3-e4', 'game-showdown-s3-e3', 'game-showdown-s3-e2', 'game-showdown-s2e15']
    },

    'Web Dev Guessing Game': {
        name: 'Web Dev Guessing Game',
        description: '',
        thumbnail: '/assets/images/playalong/web-dev-guessing-game.jpg',
        creator: creators.Syntax,
        episodes: ['web-dev-guessing-game-syntax-e1']
    },
    'Fighting Game Sound Trivia': {
        name: 'Fighting Game Sound Trivia',
        description: '',
        thumbnail: '/assets/images/playalong/fighting-game-sound-trivia.jpg',
        creator: creators.WoolieVSTheAlgorithm,
        episodes: ['fighting-game-sound-trivia-holiday-matsuri-2024']
    }
}

export const episodes: Record<string, Episode> = {
    'game-showdown-s3-e4': {
        ...JSON.parse(JSON.stringify(gameShowdownS3E4)),
        series: shows['Game Showdown']
    },
    'game-showdown-s3-e3': {
        ...JSON.parse(JSON.stringify(gameShowdownS3E3)),
        series: shows['Game Showdown']

    },
    'um-actually-s2e2': {
        ...JSON.parse(JSON.stringify(umActuallyS2E2)),
        series: shows['Um Actually']

    },
    'fighting-game-sound-trivia-holiday-matsuri-2024': {
        ...JSON.parse(JSON.stringify(fightingGameSoundTriviaHolidayMatsuri2024)),
        series: shows['Fighting Game Sound Trivia']
    },
    'web-dev-guessing-game-syntax-e1': {
        ...JSON.parse(JSON.stringify(webDevGuessingGameSyntaxE1)),
        series: shows['Web Dev Guessing Game']
    },
    'game-showdown-s3-e2': {
        ...JSON.parse(JSON.stringify(gameShowdownS3E2)),
        series: shows['Game Showdown']
    },
    'game-showdown-s2e15': {
        ...JSON.parse(JSON.stringify(gameShowdownS2E15)),
        series: shows['Game Showdown']
    },
    'the-mcelroy-family-club-house-2025-01-03': {
        ...JSON.parse(JSON.stringify(theMcElroyFamilyClubHouse20250103)),
        series: shows['The McElroy Family Clubhouse']
    },
    'the-board-game-quiz-show-s5e5': {
        ...JSON.parse(JSON.stringify(theBoardGameQuizShowS5E5)),
        series: shows['The Board Game Quiz Show']
    },
    'hankschannel-real-or-fake-e1': {
        ...JSON.parse(JSON.stringify(hankschannelRealOrFakeE1)),
        series: shows['Real or Fake Hank Tweets']
    },
    'dirty-laundry-s4e3': {
        ...JSON.parse(JSON.stringify(dirtyLaundryS4E3)),
        series: shows['Dirty Laundry']
    },
    'arcade-pit-gaming-quiz-time-s1': {
        ...JSON.parse(JSON.stringify(arcadePitGamingQuizTimeS1)),
        series: shows['Arcade Pit']
    },
    'leet-heat-s1e1': {
        ...JSON.parse(JSON.stringify(leetHeatS1E1)),
        series: shows['Leet Heat']
    },
    'leet-heat-s1e2': {
        ...JSON.parse(JSON.stringify(leetHeatS1E2)),
        series: shows['Leet Heat']
    },
    'thePrimeTime-terminal-family-feud-ep1': {
        ...JSON.parse(JSON.stringify(thePrimeTimeTerminalFamilyFeudEp1)),
        series: shows['Terminal Feud']
    },
    'um-actually-s2e19': {
        title: 'The Um Actually Holiday Special',
        episode: 'um-actually-s2e19',
        description:
            'Shane Crown, Jon Gutierrez, and Amy Vorpahl celebrate fictional holidays & play "name that Santa."',
        series: shows['Um Actually'],
        premiereDate: '2024-12-10',
        releaseDate: '2019-12-07',
        videoUrl:
            'https://www.youtube.com/watch?v=pvzEaPpLq48&ab_channel=Um%2CActually',
        videoPreview: 'https://i.ytimg.com/vi/pvzEaPpLq48/maxresdefault.jpg',
        startTime: 0,
        endTime: 1935,
        totalPrompts: 14,
        introMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        events: [
            {
                id: '75f22dff-5a94-4fb2-9cc7-255204f4e295',
                startTime: 50,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 4,
                points: 10,
                endTime: 62,
                choices: [
                    '...Robanukah, Robonzaa, and Robomadan...',
                    '...characters called "The Holiday Trinity," ...',
                    '...Robot Santa...',
                    '...Kwanzaa-bot...',
                    '...The Chanukomputer...'
                ]
            },
            {
                id: 'f9e8073b-7db0-4282-a295-4deb7652ac42',
                startTime: 68,
                type: 'results',
                resultsFor: '75f22dff-5a94-4fb2-9cc7-255204f4e295'
            },
            {
                id: '31c64185-9926-4357-870a-562fb86c1169',
                startTime: 137,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 3,
                points: 10,
                choices: [
                    '..."The Night of the Meek"...',
                    '...down-on-his-luck, recently fired department store Santa...',
                    '...he is accused of stealing the items...',
                    '...the episode ends with him drunk and in jail....'
                ],
                endTime: 156
            },
            {
                id: '32b45534-ac08-4d88-aca0-e313ef831453',
                startTime: 215,
                type: 'results',
                resultsFor: '31c64185-9926-4357-870a-562fb86c1169'
            },
            {
                id: '821ff6a7-97fc-4182-a833-0dfdedd44531',
                startTime: 326,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 4,
                points: 10,
                choices: [
                    'Towards the end of the film...',
                    '"Snow White and the Seven Dwarves."',
                    '...sing along with the song "Heigh-ho."...',
                    '...When Billy, Kate, and Gizmo blow up the movie theatre,...',
                    '...the gremlins are all destroyed except for their mohawk-sporting leader, Spike...',
                    '...who had left in search of Milk Duds.'
                ],
                endTime: 344
            },
            {
                id: '591ba2b7-817b-4eee-9fd2-5065ca7553d1',
                startTime: 369,
                type: 'results',
                resultsFor: '821ff6a7-97fc-4182-a833-0dfdedd44531'
            },
            {
                id: '36a2311f-01e0-4baa-b616-9b7881bf2ada',
                startTime: 436,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 2,
                points: 10,
                choices: [
                    '...The Feast of Winter Veil is celebrated with merriment, gift-giving, and quest-giving...',
                    '...Players can meet both an orc and a dwarf version of Greatfather Winter...',
                    "...a character based on an in-universe children's story...",
                    '...that many citizens  of Azeroth lament has been over-commercialized...',
                    '...by the Copperpinch and Jinglepocket goblin families.'
                ],
                endTime: 455
            },
            {
                id: 'c58fccb7-af3b-432e-b184-b5cc531d10e3',
                startTime: 507,
                type: 'results',
                resultsFor: '36a2311f-01e0-4baa-b616-9b7881bf2ada'
            },
            {
                id: '7c79518c-2e4d-4c65-a31c-635d1cb86df9',
                startTime: 534,
                type: 'numberCurve',
                pause: true,
                question: 'How many of these creatures are from the Americas?',
                answer: '0',
                points: 10,
                stepAmount: 1,
                stepDrop: 0,
                endTime: 545
            },
            {
                id: '65a8567b-89fe-4c9e-b718-044a573c9c48',
                startTime: 803,
                type: 'results',
                resultsFor: '7c79518c-2e4d-4c65-a31c-635d1cb86df9'
            },
            {
                id: '12a9b652-1942-49b9-bbf3-5a241c3b6b00',
                startTime: 905,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 1,
                points: 10,
                choices: [
                    'Mousekewitz family celebrating Hannukah in their homeland of Russia...',
                    "...Mama and Papa Mousekewitz give their children two gifts they've bought...",
                    '...a headscarf for Tanya and...',
                    "...Fievel's trademark blue hat...",
                    '...the Mouse of Minsk, who was as tall as a tree and had a tail a mile-long.'
                ],
                endTime: 923
            },
            {
                id: '6adc847e-21c4-4d65-82a3-8b3fce1f472a',
                startTime: 943,
                type: 'results',
                resultsFor: '12a9b652-1942-49b9-bbf3-5a241c3b6b00'
            },
            {
                id: '28db2855-dfd0-4425-9426-6d3c2dda189b',
                startTime: 975,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 1,
                points: 10,
                choices: [
                    '...one who devours your entrails and thoroughly enjoys it,...',
                    '...takes on a contract from a disgruntled child...',
                    '...Lobo lays gruesome waste to Santa and his workshop,...',
                    '...eventually stealing his sleigh and using the "naughty" and "nice"...',
                    '...map to drop hydrogen bombs all over the world....'
                ],
                endTime: 996
            },
            {
                id: '6b5a538c-18e6-4561-8b8d-1d0edfc56e5a',
                startTime: 1014,
                type: 'results',
                resultsFor: '28db2855-dfd0-4425-9426-6d3c2dda189b'
            },
            {
                id: '4f9aa272-14e4-499c-b649-a0e01e676cf1',
                startTime: 1042,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 0,
                points: 10,
                choices: [
                    'Unique to Discworld is the holiday of Hogswatch...',
                    '...a Christmas-like celebration of both the Winter Solstice and New Year...',
                    '... king overheard three sisters crying because they had no food...',
                    '...The king threw them a bag of sausages, allowing them to eat...',
                    '...although he did accidentally knock one of the sisters unconscious with the throw.'
                ],
                endTime: 1061
            },
            {
                id: 'dc16b4ae-8f96-430c-88a4-88a5b380d845',
                startTime: 1103,
                type: 'results',
                resultsFor: '4f9aa272-14e4-499c-b649-a0e01e676cf1'
            },
            {
                id: 'b1ec6c25-9556-4233-b97a-2faba126756d',
                startTime: 1254,
                type: 'numberCurve',
                pause: true,
                question:
                    'How many of these are “Real” Santas in their respective universes? ',
                answer: '4',
                points: 10,
                stepAmount: 1,
                endTime: 1295
            },
            {
                id: 'b588606c-a690-4f41-83fa-ac568ffececa',
                startTime: 1498,
                type: 'results',
                resultsFor: 'b1ec6c25-9556-4233-b97a-2faba126756d'
            },
            {
                id: '2a978aea-098b-4114-8edc-9edcac96b290',
                startTime: 1520,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 5,
                points: 10,
                choices: [
                    '..."A Muppet Christmas Carol,"...',
                    '..."A Very Merry Muppet Christmas Movie,"...',
                    '..."A Muppet Family Christmas,"...',
                    '..."The Christmas Toy."...',
                    '..."John Denver & The Muppets: A Christmas Together."...',
                    '...the last of which is the story of Santa Claus followed...',
                    '...by a performance of "Silent Night."'
                ],
                endTime: 1541
            },
            {
                id: '2a4e1112-ec4f-4e74-b40e-6045bb751e62',
                startTime: 1569,
                type: 'results',
                resultsFor: '2a978aea-098b-4114-8edc-9edcac96b290'
            },
            {
                id: 'e0fe78d9-188f-4df0-9b78-0b35fa258c63',
                startTime: 1591,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 3,
                points: 10,
                choices: [
                    '...instead of watching "It\'s a Wonderful Life" as intended,...',
                    '...Batman and Robin see a special broadcast made by Joker...',
                    '...In it, Joker performs to a "live studio audience" of cardboard cutouts...',
                    '...along with Harley Quinn as "Laughy the Christmas Elf."...',
                    '...kidnapped Commissioner Gordon, Summer Gleeson, and Harvey Bullock...'
                ],
                endTime: 1613
            },
            {
                id: 'fade3e2d-f900-48eb-b4bb-e11c40dbc5e1',
                startTime: 1667,
                type: 'results',
                resultsFor: 'e0fe78d9-188f-4df0-9b78-0b35fa258c63'
            },
            {
                id: '88b147b2-1a6d-4a0a-9a85-25c6263d431c',
                startTime: 1696,
                type: 'multiple',
                pause: true,
                question: 'Which of these traps was NOT used in Home Alone 1 or 2?  ',
                answer: 4,
                points: 10,
                choices: [
                    'Staple Gun and Doorknob',
                    'Hole',
                    'Tool Chest',
                    'Light Bulb and Iron',
                    'Mouse Trap',
                    'Fire',
                    'Battery and Sink'
                ],
                endTime: 1716
            },
            {
                id: '6c5edc52-8dfe-432b-98ba-d742ec8f906c',
                startTime: 1719,
                type: 'results',
                resultsFor: '88b147b2-1a6d-4a0a-9a85-25c6263d431c'
            },
            {
                id: 'b723e7aa-e369-4738-97fe-8a50ccd51489',
                startTime: 1741,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 3,
                points: 10,
                choices: [
                    '...you should immediately make a new, fresh cut at the bottom of the tree stem...',
                    '...with capacity for at least one   gallon of water...',
                    '...away from heat sources like fires, heaters, and electronics....',
                    '...Water the tree immediately, ideally with a plant-food mixture of some kind,...',
                    '...and make sure to regularly maintain the water level.'
                ],
                endTime: 1756
            },
            {
                id: '1d74668b-2355-4b94-823f-bc40e63e97a1',
                startTime: 1798,
                type: 'results',
                resultsFor: 'b723e7aa-e369-4738-97fe-8a50ccd51489'
            },
            {
                id: 'e105fb10-7f9b-41cf-8b1b-d2ddbd671a06',
                startTime: 1828,
                type: 'multiple',
                pause: true,
                question: "What's wrong with this statement?",
                answer: 1,
                points: 10,
                choices: [
                    '...Chewbacca goes to the wookiee homeworld of Kashyyyk to see his family for Life Day....',
                    '...The special is notable for bringing back fan-favorite characters like R2-D2, Boba Fett, and Han Solo...',
                    "...new characters for the first time, like Chewbacca's son, Lumpy, and his father, Itchy....",
                    '...musical performance by Jefferson Starship, appearing as a hologram band.'
                ],
                endTime: 1850
            },
            {
                id: 'a8f274c7-18e7-4716-b130-b052b4b250c0',
                startTime: 1886,
                type: 'results',
                resultsFor: 'e105fb10-7f9b-41cf-8b1b-d2ddbd671a06'
            },
            {
                id: 'fc9d84bf-229b-4015-b3e7-9ac364268dc8',
                startTime: 1909,
                type: 'finalResults'
            }
        ]
    },
    'um-actually-s5e23': {
        title: 'The Nutcracker, The Nightmare Before Christmas, White Christmas',
        series: shows['Um Actually'],
        episode: 'um-actually-s5e23',
        description:
            'Emma Fyffe, Amy Vorphal, and Winston A. Marshall ho ho throw down in a holiday themed episode.',
        premiereDate: '2021-12-17',
        releaseDate: '2024-12-09',
        videoUrl:
            'https://www.youtube.com/watch?v=Cmc_rJ99afw&ab_channel=Um%2CActually',
        videoPreview: 'https://i.ytimg.com/vi/Cmc_rJ99afw/maxresdefault.jpg',
        startTime: 0,
        endTime: 1907,
        totalPrompts: 18,
        introMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        events: [
            {
                id: '5601ad3b-7373-4fba-9e15-6a70f302a3ac',
                startTime: 119,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    '...Martians Momar and Kimar...',
                    '...Bomar and Girmar...',
                    '...kidnap Santa Claus....',
                    '...kidnap the wrong one.'
                ],
                endTime: 139
            },
            {
                id: '893dddfd-d194-429c-ae91-6109b1f9bc00',
                startTime: 259,
                type: 'results',
                resultsFor: '5601ad3b-7373-4fba-9e15-6a70f302a3ac'
            },
            {
                id: 'eb02574d-6788-467d-a9e9-161a99ce49c0',
                startTime: 281,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 1,
                points: 5,
                choices: [
                    '...Ebeneezer Blackadder is visited by the spirit of Christmas...',
                    '...well as a glorious future that awaits Blackadder if he chooses to be good....',
                    '...Admiral Blackadder, is a high ranking official of the Galactic Empire...',
                    '...Queen Asphyxia XIX after the death of her triple husbandoid.'
                ],
                endTime: 299
            },
            {
                id: 'b6cc6264-eb24-4af7-a295-739cbad815b4',
                startTime: 330,
                type: 'results',
                resultsFor: 'eb02574d-6788-467d-a9e9-161a99ce49c0'
            },
            {
                id: '4ca67bba-f522-474a-b52a-3bf8adbdb873',
                startTime: 403,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                endTime: 422,
                choices: [
                    '... young girl who receives a nutcracker as a gift...',
                    '...gingerbread men, tin soldiers, and the nutcracker on one side...',
                    '...army of mice led by the seven-headed Mouse King...',
                    '...The tide is turned when she kills the mouse king with her shoe...'
                ]
            },
            {
                id: '5f7e4508-37c8-44bc-9290-837feee167aa',
                startTime: 522,
                type: 'results',
                resultsFor: '4ca67bba-f522-474a-b52a-3bf8adbdb873'
            },
            {
                id: 'a9cc386d-5ccc-4be4-ae6a-4477057de91f',
                startTime: 589,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 0,
                points: 5,
                endTime: 602,
                choices: [
                    '... titular leather-clad heroine and the undertaker Enzo...',
                    '...doing some Christmas shopping when angels attack the city....',
                    '...Bayonetta resumes her shopping...',
                    '...taking advantage of post-holiday sales with her friend Jeanne.'
                ]
            },
            {
                id: '7f5a7b8c-b38f-4acf-a1e8-d352ab29f577',
                startTime: 689,
                type: 'results',
                resultsFor: 'a9cc386d-5ccc-4be4-ae6a-4477057de91f'
            },
            {
                id: '526f422f-9537-436b-9aed-339cf048798b',
                startTime: 779,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: ['The Nightmare Before Christmas'],
                points: 5,
                endTime: 787
            },
            {
                id: '39f09fb5-b54b-4aa5-a64b-0513a65ab085',
                startTime: 788,
                type: 'quickResults',
                resultsFor: '526f422f-9537-436b-9aed-339cf048798b'
            },
            {
                id: 'c9989fb0-b191-4631-83de-114f10fb518b',
                startTime: 798,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: ['Jingle Jangle'],
                points: 5,
                endTime: 807
            },
            {
                id: '225b5d0f-1066-4687-8a71-76ed8478d3e7',
                startTime: 836,
                type: 'quickResults',
                resultsFor: 'c9989fb0-b191-4631-83de-114f10fb518b'
            },
            {
                id: '4a1ba7f9-899f-4e6d-a1f9-a2dd33f40e75',
                startTime: 849,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: ['Eight Crazy Nights', '8 Crazy Nights'],
                points: 5,
                endTime: 859
            },
            {
                id: '8cf2cfc3-84a1-474c-b284-1e7b01f7caf6',
                startTime: 860,
                type: 'quickResults',
                resultsFor: '4a1ba7f9-899f-4e6d-a1f9-a2dd33f40e75'
            },
            {
                id: '54d44ca7-7f8f-45d5-b90f-199edb3210c6',
                startTime: 886,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: [
                    'How the Grinch Stole Christmas',
                    "Dr. Seuss' How the Grinch Stole Christmas!",
                    'The Grinch'
                ],
                points: 5,
                endTime: 894
            },
            {
                id: '6f74a25e-7a79-4ca3-815b-3f4f7d2016cf',
                startTime: 895,
                type: 'quickResults',
                resultsFor: '54d44ca7-7f8f-45d5-b90f-199edb3210c6'
            },
            {
                id: '09226ca8-9ab8-4aff-8bb7-26dcfcfd68b3',
                startTime: 909,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: ['Rudolph the Red-Nosed Reindeer', 'Rudolph'],
                points: 5,
                endTime: 915
            },
            {
                id: 'd94f7eb4-69d7-459e-9ea5-d991c0269bad',
                startTime: 916,
                type: 'quickResults',
                resultsFor: '09226ca8-9ab8-4aff-8bb7-26dcfcfd68b3'
            },
            {
                id: '594177f4-d058-45a3-82a2-4745a6da7d1b',
                startTime: 987,
                type: 'stringCompare',
                pause: true,
                question: 'Guess the Movie or Show',
                acceptableAnswers: ['The Muppet Christmas Carol'],
                points: 5,
                endTime: 996
            },
            {
                id: 'c27a574c-8db2-4242-a643-0fbe50ad0efb',
                startTime: 997,
                type: 'results',
                resultsFor: '594177f4-d058-45a3-82a2-4745a6da7d1b'
            },
            {
                id: '9c233e5d-c11c-4a6b-839c-abbaa43dbf08',
                startTime: 1029,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 2,
                points: 5,
                choices: [
                    '...a Finnish reindeer farmer lays a trap for wolves...',
                    '...but accidentally traps a strange, naked old man...',
                    '...who turns out to be Santa Claus...',
                    '...this version of Santa attacks naughty children.'
                ],
                endTime: 1043
            },
            {
                id: '83f6c77c-f53b-42a3-a5d5-46cfd43ee6cb',
                startTime: 1113,
                type: 'results',
                resultsFor: '9c233e5d-c11c-4a6b-839c-abbaa43dbf08'
            },
            {
                id: 'fc7d24e4-73df-446f-9818-8eff57fe7c74',
                startTime: 1239,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 2,
                points: 5,
                choices: [
                    '...Jack Skellington enters Christmas Town by...',
                    '... a Christmas Tree-shaped door set into a tree in the woods...',
                    '...This is just one of five doors, suggesting that other holiday-themed worlds exist...',
                    '...a turkey, an easter egg, a firecracker, and a heart.'
                ],
                endTime: 1255
            },
            {
                id: '6bd04eec-8d9c-4cb5-b473-37d32037e079',
                startTime: 1265,
                type: 'results',
                resultsFor: 'fc7d24e4-73df-446f-9818-8eff57fe7c74'
            },
            {
                id: '9a8875f0-e4cd-413d-b510-ef82e2ac4005',
                startTime: 1335,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 0,
                points: 5,
                endTime: 1355,
                choices: [
                    '...Matt and Joe are the sole inhabitants of a cabin who spend a snowy Christmas Day telling each other their pasts...',
                    '...Matt used to train digital clones as personal assistants...',
                    '...recorded sexual encounters with a device called Z-Eyes...',
                    "...blocked by his fiancee, Beth, and confesses to murdering Beth's father...."
                ]
            },
            {
                id: 'f4861d45-23fb-485a-8b68-584fe40fb5b8',
                startTime: 1416,
                type: 'results',
                resultsFor: '9a8875f0-e4cd-413d-b510-ef82e2ac4005'
            },
            {
                id: '6156adaa-e8db-4970-8b17-37f09fa32eff',
                startTime: 1505,
                type: 'multiple',
                pause: true,
                question: 'Which movies does not take place around Christmas?',
                answer: 1,
                points: 5,
                endTime: 1514,
                choices: [
                    'Jurassic World',
                    'Batman',
                    'Iron Man 3',
                    'Lethal Weapon',
                    'In Bruges',
                    'Eyes Wide Shut'
                ]
            },
            {
                id: '27052d59-f3a5-456d-ab6e-783641169630',
                startTime: 1529,
                type: 'quickResults',
                resultsFor: '6156adaa-e8db-4970-8b17-37f09fa32eff'
            },
            {
                id: '6c1e454d-1cc3-4c53-a8ef-afd8ddac5ff4',
                startTime: 1536,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 1,
                points: 5,
                endTime: 1552,
                choices: [
                    'In the Tales from the Crypt episode "And All Through the House,"...',
                    '...homicidal maniac dressed as Santa who kills her husband...',
                    '...and tries to break into her house. The maniac eventually gets in when...',
                    "...Elizabeth's daughter lets him in the front door, thinking he's Santa Claus."
                ]
            },
            {
                id: '35bb510c-d98b-4ce1-a9c4-0193aff0269b',
                startTime: 1615,
                type: 'results',
                resultsFor: '6c1e454d-1cc3-4c53-a8ef-afd8ddac5ff4'
            },
            {
                id: '3385cc6c-c563-4867-9968-f2ed34eecfe0',
                startTime: 1638,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 0,
                points: 5,
                choices: [
                    '... the Spellman family Christmas is disrupted when they discover their house is haunted...',
                    '...by Gryla and the Yule Lads.  Though initially antagonistic toward the family,...',
                    '...Gryla ultimately helps them fight the demon Bartel...',
                    '...who has been dressing as a mall santa and trapping the souls of children in wax....'
                ],
                endTime: 1654
            },
            {
                id: 'b4ecff7a-57c2-4a8a-8e66-94981bf36130',
                startTime: 1724,
                type: 'results',
                resultsFor: '3385cc6c-c563-4867-9968-f2ed34eecfe0'
            },
            {
                id: '0f6f1e18-b79b-4290-a68c-2bc9d69e5110',
                startTime: 1771,
                type: 'stringCompare',
                pause: true,
                question: 'Who is this?',
                acceptableAnswers: ['The Grinch', 'How the Grinch stole Christmas'],
                points: 5,
                endTime: 1784
            },
            {
                id: '1a7ecbc3-27d8-48e8-934b-fce939b54e7a',
                startTime: 1790,
                type: 'results',
                resultsFor: '0f6f1e18-b79b-4290-a68c-2bc9d69e5110'
            },
            {
                id: 'a70eb149-5a21-482f-b91c-55c593e99713',
                startTime: 1820,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    "'Tis the season... for colds!...",
                    "...you'll have a choice to make between generic and brand name drugs....",
                    '...While generic drugs are cheaper,...',
                    '...brand name drugs often act faster or have longer lasting effects....'
                ],
                endTime: 1832
            },
            {
                id: 'b439a7c2-f9a6-4749-97e4-e0b156e937aa',
                startTime: 1841,
                type: 'results',
                resultsFor: 'a70eb149-5a21-482f-b91c-55c593e99713'
            },
            {
                id: '285effa4-3246-4cfe-82e9-c5c931921e74',
                startTime: 1864,
                type: 'finalResults'
            }
        ]
    },
    'um-actually-s2e1': {
        title:
            "C-3PO's Origins, HP Lovecraft, the Food Album (with Weird Al Yankovic) [Full Episode]",
        episode: 'um-actually-s2e1',
        description:
            'Caldwell Tanner, Siobhan Thompson, and Nate Dern inspect guns and review the Diagon Alley bar scene.',
        premiereDate: '2020-09-11',
        releaseDate: '2024-11-27',
        videoUrl:
            'https://www.youtube.com/watch?v=ZtMM2c__sfw&ab_channel=Um%2CActually',
        videoPreview: 'https://i.ytimg.com/vi/ZtMM2c__sfw/maxresdefault.jpg',
        startTime: 0,
        endTime: 1312,
        totalPrompts: 12,
        introMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        events: [
            {
                id: 'a7d42284-336b-4829-a277-081d668272d4',
                startTime: 49,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 2,
                points: 5,
                choices: [
                    "C-3PO's first encounter with a member of the Skywalker family...",
                    'occurs not when he meets Luke Skywalker on the desert planet of Tatooine...',
                    'but when he meets princess Leia Organa...',
                    'aboard her Alderaan Cruiser.'
                ],
                endTime: 59
            },
            {
                id: '15ea7109-dd2b-4741-9ada-ff2f7a066a49',
                startTime: 71,
                type: 'results',
                resultsFor: 'a7d42284-336b-4829-a277-081d668272d4'
            },
            {
                id: '6e031e6a-0794-4dde-87d9-6dc59ac17ff8',
                startTime: 141,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 0,
                points: 5,
                choices: [
                    '...Three Broomsticks...',
                    "...Weasleys' Wizard Wheezes...",
                    "...Ollivander's Wand Shop...",
                    "...Gringott's, the Wizard Bank..."
                ],
                endTime: 158
            },
            {
                id: '28aa0309-05d6-4d25-b0fe-e704d0d2b580',
                startTime: 164,
                type: 'results',
                resultsFor: '6e031e6a-0794-4dde-87d9-6dc59ac17ff8'
            },
            {
                id: '0d44032d-c1d4-4b35-8c27-dd4576cfc546',
                startTime: 191,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 1,
                points: 5,
                endTime: 195,
                choices: [
                    'Brienne of Tarth and Sandor "The Hound" Clegane...',
                    'both knights of Westeros and...',
                    'at times members of two separate Kingsguards...'
                ]
            },
            {
                id: 'f754dda0-0347-4b0f-955c-2f7901fa57e7',
                startTime: 206,
                type: 'results',
                resultsFor: '0d44032d-c1d4-4b35-8c27-dd4576cfc546'
            },
            {
                id: '476bfb86-3318-4491-bff8-a655683d1bc8',
                startTime: 296,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    'The mighty Protoss, psionic warriors from the homeworld of Aiur...',
                    'have vast armies to wage war against the Terran and Zerg, ',
                    'including their fearsome Zealots,',
                    'their AI-piloted Dragoons,',
                    'and their invisible dark templar.'
                ],
                endTime: 308
            },
            {
                id: 'e86b45c1-a23b-4ea2-9ec0-df3dc0857f3a',
                startTime: 364,
                type: 'results',
                resultsFor: '476bfb86-3318-4491-bff8-a655683d1bc8'
            },
            {
                id: 'ba8cd58a-9dd4-424b-bce1-35560379f2d1',
                startTime: 504,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    "Ender Wiggin's two older siblings, Valentine and Peter...",
                    'become the most powerful political entity on the planet Earth...',
                    'y pretending to be two adults named Demosthenes and Locke...',
                    'and overthrowing the world government through a military coup.'
                ],
                endTime: 514
            },
            {
                id: '04253bfe-f616-4536-936e-5538bf65e9ac',
                startTime: 545,
                type: 'results',
                resultsFor: 'ba8cd58a-9dd4-424b-bce1-35560379f2d1'
            },
            {
                id: '861a53ea-09c7-4ff2-a0cb-0da421285edb',
                startTime: 570,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    "I've written a lot of songs about food.",
                    'So many, in fact, that at one point my record label released an entire compilation album called The Food Album...',
                    'with songs like Spam...',
                    'Grapefruit Diet...',
                    'and I Love Rocky Road.'
                ],
                endTime: 584
            },
            {
                id: '0db6f7de-c6f7-4f80-a079-7797f6b7eb7c',
                startTime: 590,
                type: 'results',
                resultsFor: '861a53ea-09c7-4ff2-a0cb-0da421285edb'
            },
            {
                id: '24728b66-79c2-4966-974a-a3522342805c',
                startTime: 653,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                choices: [
                    "Lyra Belequa's daemon, Pantalaimon, is an animal companion capable of changing shape...",
                    "and in some ways represents Lyra's soul.",
                    "In Lyra's world, people's daemons change shape all the time to...",
                    'reflect their mood or personality, until the person dies.'
                ],
                endTime: 665
            },
            {
                id: '2ddea9ab-147c-4f39-90ad-411b3f4b6351',
                startTime: 688,
                type: 'results',
                resultsFor: '24728b66-79c2-4966-974a-a3522342805c'
            },
            {
                id: '4ae5c328-0a82-4f3a-8b74-27cbd74afbd6',
                startTime: 734,
                type: 'multiple',
                pause: true,
                question: 'Which item is out of place with the other items?',
                answer: 1,
                points: 5,
                choices: [
                    'Far Left',
                    'Middle Left',
                    'Middle Right',
                    'Far Right',
                    'Bottom'
                ]
            },
            {
                id: 'd84a384b-9827-4585-a80d-9dda6dc55db5',
                startTime: 748,
                type: 'results',
                resultsFor: '4ae5c328-0a82-4f3a-8b74-27cbd74afbd6'
            },
            {
                id: '43dd9a2a-f4c9-4d45-9e0c-6904b8ec7809',
                startTime: 827,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 0,
                points: 5,
                endTime: 843,
                choices: [
                    'Anduril, which means Flame of the West, was the name of the sword wielded by Elendil...',
                    'during the Last Alliance of Elves and Men.',
                    "Once broken, Elendil's son Isildur used the broken handle-shard of Anduril to cut the One Ring from Sauron's hand.",
                    '3,000 years later, it was reforged and given to Aragorn, son of Arathorn.'
                ]
            },
            {
                id: 'f99dfb47-249e-48b6-b4d9-14618d4c87cc',
                startTime: 876,
                type: 'results',
                resultsFor: '43dd9a2a-f4c9-4d45-9e0c-6904b8ec7809'
            },
            {
                id: '69ea5a6e-bcfa-4c77-90af-7412cf04f895',
                startTime: 902,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 5,
                endTime: 913,
                choices: [
                    'In "Dragon Ball Z," character names follow peculiar patterns of references and puns.',
                    'Saiyans are all named after vegetables,',
                    'Namekians are named after musical instruments and snails,',
                    'and gods of destruction are named after types of underwear.'
                ]
            },
            {
                id: '78612dac-0391-49eb-a0e2-4fdc5c058560',
                startTime: 968,
                type: 'results',
                resultsFor: '69ea5a6e-bcfa-4c77-90af-7412cf04f895'
            },
            {
                id: 'a26ceb3a-972d-427a-b42c-28e8575609ab',
                startTime: 1135,
                type: 'multiple',
                pause: true,
                question: 'What feature of the manticore is missing?',
                answer: 3,
                points: 5,
                choices: [
                    'A Tail that is the head of a Snake',
                    'A Goat Head',
                    'A Dragon Head',
                    'Wings'
                ]
            },
            {
                id: '97b83b17-87da-4fa0-844d-b3f3de5496d1',
                startTime: 1141,
                type: 'results',
                resultsFor: 'a26ceb3a-972d-427a-b42c-28e8575609ab'
            },
            {
                id: 'ddb88322-1f65-4857-8bf6-45deb2ffc89f',
                startTime: 1230,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                answer: 3,
                points: 10,
                endTime: 1245,
                choices: [
                    "California, the state you all live in, will elect a new governor next year. Even though we're more than a year away several people have already announced their candidacy...",
                    ' including Lt. Governor Gavin Newsom...',
                    'former Speaker of the State Assembly Antonio Villaraigosa...',
                    'and current LA mayor Eric Garcetti.'
                ]
            },
            {
                id: '11d71499-bcc1-480c-a3e1-10704544863e',
                startTime: 1276,
                type: 'quickResults',
                resultsFor: 'ddb88322-1f65-4857-8bf6-45deb2ffc89f'
            },
            {
                id: '6843d060-aabe-4f3f-822b-1a9af528de1d',
                startTime: 1346,
                type: 'finalResults'
            }
        ],
        series: shows['Um Actually']
    },
    'arcade-pit-halloween-2024': {
        series: shows['Arcade Pit'],
        title: 'Arcade Pit: Halloween Special, 2024!',
        episode: 'arcade-pit-halloween-2024',
        description: 'The return of the annual halloween-themed Arcade Pit!',
        introMusic: { url: 'https://www.youtube.com/watch?v=AgIuO71I818&ab_channel=TieTuesdayStreamArchives', startTime: 0, endTime: 999, source: 'youtube' },
        promptMusic: { url: '/assets/audio/playalong/mtvremote.mp3', startTime: 0, endTime: 999, source: 'mp3' },
        premiereDate: '2024-10-27',
        releaseDate: '2024-11-21',
        videoUrl: 'https://www.youtube.com/watch?v=h1xMEjMZv9Y&ab_channel=Smight',
        videoPreview: 'https://i.ytimg.com/vi/h1xMEjMZv9Y/sddefault.jpg',
        startTime: 0,
        endTime: 5728,
        totalPrompts: 29,
        events: [
            {
                id: '48419cf8-185f-40d0-ac5c-e03f7cf5eab2',
                startTime: 0,
                type: 'multiple',
                pause: true,
                question: 'Call your shot! Which team do you think will win?',
                answer: 1,
                points: 20,
                choices: ['Blue', 'Yellow'],
                endTime: 35
                // endTime: 5
            },
            {
                id: '800ae712-c320-41f1-999c-9f8525e0910e',
                startTime: 37,
                type: 'multiple',
                pause: true,
                question: 'Who wins this challenge?',
                answer: 1,
                points: 20,
                endTime: 92,
                choices: ['thevoiceofdog', 'Wobbly Python', 'TieTuesday', 'authorblues']
            },
            {
                id: 'ff2e14e1-9ebf-456a-b419-c75286fdcfc0',
                startTime: 204,
                type: 'results',
                resultsFor: '800ae712-c320-41f1-999c-9f8525e0910e'
            },
            {
                id: '68eec576-bd14-48ce-8b21-0ef4644ef031',
                startTime: 321,
                type: 'multiple',
                pause: true,
                question: 'Which teams wins the relay race?',
                answer: 0,
                points: 30,
                endTime: 436,
                choices: ['Blue', 'Yellow']
            },
            {
                id: '5bf95e1b-df85-4b49-ad5c-b8c62c73ae2f',
                startTime: 788,
                type: 'results',
                resultsFor: '68eec576-bd14-48ce-8b21-0ef4644ef031'
            },
            {
                id: '761bffa8-ab76-405a-b619-cd5e990ceee3',
                startTime: 922,
                type: 'multiple',
                pause: true,
                question: "What is Demonic Eye's final form?",
                answer: 0,
                points: 30,
                choices: [
                    'He gets smaller',
                    'He doubles in size',
                    'He splits into 3 eyes',
                    'He grows tentacles'
                ],
                endTime: 1041
            },
            {
                id: 'ead10499-d22a-49fd-bceb-01531c259865',
                startTime: 1044,
                type: 'results',
                resultsFor: '761bffa8-ab76-405a-b619-cd5e990ceee3'
            },
            {
                id: '934a27b5-aa22-43e8-910f-995996d64970',
                startTime: 1139,
                type: 'multiple',
                pause: true,
                question: 'Which team wins the team challenge?',
                answer: 0,
                points: 10,
                choices: ['Yellow', 'Blue'],
                endTime: 1233
            },
            {
                id: '6e60ea72-ef54-4799-98df-0c78132aeee5',
                startTime: 1362,
                type: 'results',
                resultsFor: '934a27b5-aa22-43e8-910f-995996d64970'
            },
            {
                id: 'b5e685c6-ed80-40d6-925b-f5983087c548',
                startTime: 1475,
                type: 'multiple',
                pause: true,
                question: 'Which AI Monster wins the battle?',
                answer: 0,
                points: 30,
                choices: ['Cyber Woo', 'Atomic Guy'],
                endTime: 1523
            },
            {
                id: 'f0ce396a-d453-4f9e-ac79-3edb61e540d4',
                startTime: 1671,
                type: 'results',
                resultsFor: 'b5e685c6-ed80-40d6-925b-f5983087c548'
            },
            {
                id: 'd7413e04-cafc-4f60-b922-25ee9139dbd2',
                startTime: 1785,
                type: 'multiple',
                pause: true,
                question: 'Which of these lines can Mr. Green say when he wins?',
                answer: 0,
                points: 10,
                choices: [
                    "Ya' never shoulda messed with me, kid!",
                    "All in a day's work for someone like me!",
                    "You'll never get one by me!",
                    "That's why they call me Green the Genius!"
                ]
            },
            {
                id: 'd9569eb8-1261-4081-ad1c-3874f35e9950',
                startTime: 1806,
                type: 'results',
                resultsFor: 'd7413e04-cafc-4f60-b922-25ee9139dbd2'
            },
            {
                id: '1568924a-b85a-447c-9f60-30ffdbb0207a',
                startTime: 1837,
                type: 'multiple',
                pause: true,
                question:
                    "What's the label on the storage facilities mispelled as sometimes?",
                answer: 1,
                points: 10,
                choices: ['STURGE', 'STRAGE', 'STOWAGE', 'STORMAGE']
            },
            {
                id: 'cafb1c5d-b81b-4eb8-a195-c933f9470cab',
                startTime: 1845,
                type: 'results',
                resultsFor: '1568924a-b85a-447c-9f60-30ffdbb0207a'
            },
            {
                id: '183c81ec-f16c-4437-9976-71246804015d',
                startTime: 2016,
                type: 'multiple',
                pause: true,
                question: 'What is the result of this challenge?',
                answer: 1,
                points: 30,
                choices: [
                    'Arrives at Death on the first life but fails to kill death',
                    'Arrives at Death on the Second life but fails to kill death',
                    'Dies before Reaching Death',
                    'Defeats Death and gets the bonus points'
                ]
            },
            {
                id: 'cab7050b-10d5-47a6-aad6-d6f800059eb1',
                startTime: 2401,
                type: 'results',
                resultsFor: '183c81ec-f16c-4437-9976-71246804015d'
            },
            {
                id: '74e5b013-0f9e-40d2-8537-e4674b158fc8',
                startTime: 2485,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Deadly Premonition'],
                points: 10,
                threshold: 0.8
            },
            {
                id: 'aab0a7a4-c8f2-442c-8cd1-752aa66ea046',
                startTime: 2493,
                type: 'quickResults',
                resultsFor: '74e5b013-0f9e-40d2-8537-e4674b158fc8'
            },
            {
                id: '751dc726-71ad-49fb-9e3e-e96aa3346d90',
                startTime: 2501,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Bioshock'],
                points: 10,
                threshold: 0.8
            },
            {
                id: '6688e9f2-912b-4241-a61b-c4725814f79f',
                startTime: 2502,
                type: 'quickResults',
                resultsFor: '751dc726-71ad-49fb-9e3e-e96aa3346d90'
            },
            {
                id: '10a8f812-3745-46ba-80a6-33b7128a9e31',
                startTime: 2509,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: [
                    "Castlevania II - Belmont's Revenge",
                    "Belmont's Revenge",
                    'Castlevania 2',
                    'Castlevania II'
                ],
                points: 10,
                threshold: 0.8
            },
            {
                id: '4616309e-565c-4fba-9f43-8d0976065e8b',
                startTime: 2515,
                type: 'quickResults',
                resultsFor: '10a8f812-3745-46ba-80a6-33b7128a9e31'
            },
            {
                id: '3c2fe50d-c1f0-456c-a684-299230c12573',
                startTime: 2606,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: [
                    "Night Warriors: Darkstalkers' Revenge",
                    'Darkstalkers 2'
                ],
                points: 10,
                endTime: 2652,
                threshold: 0.8
            },
            {
                id: 'babff780-3996-41b3-8b67-2e77525cc116',
                startTime: 2715,
                type: 'results',
                resultsFor: '3c2fe50d-c1f0-456c-a684-299230c12573'
            },
            {
                id: '7e6c7721-c90d-48c7-95a2-77f28fd965bd',
                startTime: 2855,
                type: 'multiple',
                pause: true,
                question: 'What enemy is waiting at the end of the conveyor?',
                answer: 2,
                points: 10,
                choices: ['A', 'B', 'C', 'D', 'E', 'F']
            },
            {
                id: '322919aa-1d2c-437a-b471-4d197e9daeb2',
                startTime: 2885,
                type: 'results',
                resultsFor: '7e6c7721-c90d-48c7-95a2-77f28fd965bd'
            },
            {
                id: 'a956effc-7718-41c6-967e-9619b40e3451',
                startTime: 3062,
                type: 'multiple',
                pause: true,
                question: 'What Mario Kart Item is NOT present in the final drawings?',
                answer: 1,
                points: 10,
                choices: ['Blue Shell', 'Red Shell', 'Green Shell', 'Mushroom']
            },
            {
                id: '33614415-bff0-4dcb-addb-48ab63284072',
                startTime: 3278,
                type: 'results',
                resultsFor: 'a956effc-7718-41c6-967e-9619b40e3451'
            },
            {
                id: 'b292d8b4-0349-485e-9863-81626f8b56fe',
                startTime: 3447,
                type: 'multiple',
                pause: true,
                question: "What is Dan's Gimmick in most Street Fighter game he's in?",
                answer: 3,
                points: 30,
                choices: [
                    "He's a stronger but slower clone of Ryu",
                    "He's a faster but weaker clone of Ryu",
                    'He has a similar moveset as Ryu but more Air Based',
                    "They made him bad on purpose and he's a joke."
                ]
            },
            {
                id: 'f485e422-e5b8-4118-8444-a54d0be2fbc2',
                startTime: 3462,
                type: 'results',
                resultsFor: 'b292d8b4-0349-485e-9863-81626f8b56fe'
            },
            {
                id: '9614ce5d-db21-4270-9e38-e50129bade73',
                startTime: 3698,
                type: 'multiple',
                pause: true,
                question:
                    "When you get jumpscared by a Toppin Monster, there's a 1/10 chance of it being a special scare. What appears during this rare scare?",
                answer: 1,
                points: 15,
                choices: [
                    'BEHIND YOU!',
                    'Oktoberfest!',
                    'Pizza Time!',
                    'Happy New Year!'
                ]
            },
            {
                id: '5bf547b0-b93e-44b8-b32c-8a500aa2435b',
                startTime: 3704,
                type: 'results',
                resultsFor: '9614ce5d-db21-4270-9e38-e50129bade73'
            },
            {
                id: 'd5820648-c5c6-4a51-b200-e2b79a3159fe',
                startTime: 3734,
                type: 'multiple',
                pause: true,
                question: 'What is the name of the chainsaw wielding clown?',
                answer: 2,
                points: 15,
                choices: ['Boppo', 'Arnold', 'Adam', 'Flapjack']
            },
            {
                id: 'd63463cf-82d2-416a-9b2a-52524db9893c',
                startTime: 3738,
                type: 'results',
                resultsFor: 'd5820648-c5c6-4a51-b200-e2b79a3159fe'
            },
            {
                id: '6fd705e8-3596-4cc8-8bbf-f6090ac042d0',
                startTime: 3928,
                type: 'numberCurve',
                pause: true,
                question: 'How many bats did authorbleus jump on?',
                answer: '7',
                points: 30,
                stepAmount: 1
            },
            {
                id: '4b362643-0475-4546-af0a-b43fffcf3a96',
                startTime: 3929,
                type: 'results',
                resultsFor: '6fd705e8-3596-4cc8-8bbf-f6090ac042d0'
            },
            {
                id: '9d2538cf-b358-4842-bbaa-b60cda9ef488',
                startTime: 4043,
                type: 'multiple',
                pause: true,
                question:
                    "True Or False: Demon's Crest is a spinoff of Ghost 'N Goblins and is the actual first appearance of Firebrand. ",
                answer: 1,
                displayAnswer:
                    'False: While the The Red Arremer Tribe does appear in the game, canonically, Firebrand is not one of those demons. ',
                points: 20,
                choices: ['True', 'False'],
                endTime: 4182
            },
            {
                id: 'f65f2440-d320-4a9f-99b2-fff718fcc144',
                startTime: 4222,
                type: 'results',
                resultsFor: '9d2538cf-b358-4842-bbaa-b60cda9ef488'
            },
            {
                id: '35b50191-e4ac-4b1e-926d-f97b9afa7735',
                startTime: 4320,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['River City Girls'],
                points: 10,
                threshold: 0.8
            },
            {
                id: 'ef64f024-2556-498d-9fb6-f014fd7358e4',
                startTime: 4321,
                type: 'quickResults',
                resultsFor: '35b50191-e4ac-4b1e-926d-f97b9afa7735'
            },
            {
                id: 'f341be86-3bb4-44c2-b150-7d13f823b880',
                startTime: 4328,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Gris'],
                points: 10,
                threshold: 0.8
            },
            {
                id: 'b41148c9-a330-486b-98eb-cdc47b448faf',
                startTime: 4329,
                type: 'quickResults',
                resultsFor: 'f341be86-3bb4-44c2-b150-7d13f823b880'
            },
            {
                id: '3fab2f77-ceb8-4042-b7d8-a546cc193196',
                startTime: 4343,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Killing Time'],
                points: 10,
                threshold: 0.8
            },
            {
                id: '4e2de5a1-c01d-489e-bfe7-c826bb3af53a',
                startTime: 4397,
                type: 'results',
                resultsFor: '3fab2f77-ceb8-4042-b7d8-a546cc193196'
            },
            {
                id: '275bdae7-0f61-42b0-b974-fd4cf79d0bbc',
                startTime: 4441,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Dragon Ball Z GT: Final Bout'],
                points: 10,
                endTime: 4469,
                threshold: 0.7
            },
            {
                id: '29dba593-5af1-4c40-a05f-29bc06d42f46',
                startTime: 4570,
                type: 'results',
                resultsFor: '275bdae7-0f61-42b0-b974-fd4cf79d0bbc'
            },
            {
                id: '364d42dc-3b93-499e-83dd-9288baf8f720',
                startTime: 4726,
                type: 'stringCompare',
                pause: true,
                question: 'What is Samus Dressed As?',
                acceptableAnswers: ['Dracula', 'Vampire'],
                points: 20
            },
            {
                id: 'eef65515-ccf1-4b16-8063-ef7bc7caf50d',
                startTime: 4727,
                type: 'results',
                resultsFor: '364d42dc-3b93-499e-83dd-9288baf8f720'
            },
            {
                id: '858b1f41-8c94-4b67-9603-776857f68838',
                startTime: 4878,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['The Legend of the Mystical Ninja', 'Goemon '],
                points: 10,
                threshold: 0.7
            },
            {
                id: '8f2fb0d1-1d6e-48da-93b9-a794afb3447a',
                startTime: 4882,
                type: 'quickResults',
                resultsFor: '858b1f41-8c94-4b67-9603-776857f68838'
            },
            {
                id: 'a8321d4d-4816-4357-922d-958c59a2091f',
                startTime: 4890,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Slaughter House'],
                points: 10,
                threshold: 0.8
            },
            {
                id: 'b7ad8344-c65b-4649-8794-e98e7b30f226',
                startTime: 4929,
                type: 'quickResults',
                resultsFor: 'a8321d4d-4816-4357-922d-958c59a2091f'
            },
            {
                id: '9f105959-e9b1-492c-af23-f0909a6b8522',
                startTime: 4938,
                type: 'stringCompare',
                pause: true,
                question: 'Name That Game!',
                acceptableAnswers: ['Super C', 'Contra 2'],
                points: 10,
                threshold: 0.8
            },
            {
                id: '0ba8d50c-3bcd-4126-9594-23b59ea62b51',
                startTime: 4947,
                type: 'results',
                resultsFor: '9f105959-e9b1-492c-af23-f0909a6b8522'
            },
            {
                id: '149455ea-e067-4598-8327-57c1bc735c59',
                startTime: 4982,
                type: 'order',
                pause: true,
                question: 'Guess the order the players complete this challenge in.',
                answer: 4230,
                points: 10,
                choices: ['authorblues', 'thevoiceofdog', 'tietuesday', 'Wobblypython'],
                endTime: 5039
            },
            {
                id: '96571576-6641-4106-94a1-333ba853720a',
                startTime: 5143,
                type: 'results',
                resultsFor: '149455ea-e067-4598-8327-57c1bc735c59'
            },
            {
                id: '7dc94a15-1ed1-4ec2-a8b9-914e34c6301d',
                startTime: 5213,
                type: 'results',
                resultsFor: '48419cf8-185f-40d0-ac5c-e03f7cf5eab2'
            },
            {
                id: '1ddf8b56-8269-4e5d-866c-728a2f26ab2b',
                startTime: 5289,
                type: 'finalResults'
            }
        ]
    },
    'trivia-tower-e1': {
        series: shows['Trivia Tower'],
        title: 'Series Premiere With Dan Ryckert',
        description:
            "We're proud to present the first episode of MinnMax's new monthly series: Trivia Tower!",
        episode: 'trivia-tower-e1',
        premiereDate: '2021-02-16',
        releaseDate: '2024-11-10',
        videoUrl: 'https://youtu.be/8-TzKOuTi4Q?si=Dg5fbwKqPV8_fC5x',
        videoPreview: 'https://i3.ytimg.com/vi/8-TzKOuTi4Q/maxresdefault.jpg',
        promptMusic: { url: '/assets/audio/playalong/mtvremote.mp3', startTime: 0, endTime: 999, source: 'mp3' },
        introMusic: { url: '', startTime: 0, endTime: 999, source: 'none' },
        startTime: 0,
        endTime: 96 * 60 + 26,
        totalPrompts: 56,
        events: [
            {
                id: '1',
                startTime: 7 * 60 + 58,
                endTime: 8 * 60 + 8,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Alan Wake'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '2',
                startTime: 8 * 60 + 8 + 1,
                type: 'results',
                resultsFor: '1'
            },
            {
                id: '3',
                startTime: 9 * 60 + 37,
                endTime: 9 * 60 + 47,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Super Mario Sunshine'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '4',
                startTime: 9 * 60 + 47 + 1,
                type: 'results',
                resultsFor: '3'
            },
            {
                id: '5',
                startTime: 11 * 60 + 17,
                endTime: 11 * 60 + 45,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Legend of Zelda: Breath of The Wild'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '6',
                startTime: 11 * 60 + 45 + 1,
                type: 'results',
                resultsFor: '5'
            },
            {
                id: '7',
                startTime: 13 * 60 + 7,
                endTime: 13 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Limbo'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '8',
                startTime: 13 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '7'
            },
            {
                id: '9',
                startTime: 14 * 60 + 56,
                endTime: 15 * 60 + 36,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Bully'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '10',
                startTime: 15 * 60 + 36 + 1,
                type: 'results',
                resultsFor: '9'
            },
            {
                id: '11',
                startTime: 16 * 60 + 37,
                endTime: 17 * 60 + 2,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Galaga'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '12',
                startTime: 17 * 60 + 2 + 1,
                type: 'results',
                resultsFor: '11'
            },
            {
                id: '13',
                startTime: 17 * 60 + 54,
                endTime: 18 * 60 + 13,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Half-Life'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '14',
                startTime: 18 * 60 + 13 + 1,
                type: 'results',
                resultsFor: '13'
            },
            {
                id: '15',
                startTime: 20 * 60 + 0,
                endTime: 20 * 60 + 10,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: [
                    'Bloodstained: Ritual of the Night',
                    'Bloodstained'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '16',
                startTime: 20 * 60 + 10 + 1,
                type: 'results',
                resultsFor: '15'
            },
            {
                id: '17',
                startTime: 23 * 60 + 1,
                endTime: 23 * 60 + 40,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Final Fantasy 13', 'Final Fantasy XIII'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '18',
                startTime: 23 * 60 + 40 + 1,
                type: 'results',
                resultsFor: '17'
            },
            {
                id: '19',
                startTime: 25 * 60 + 12,
                endTime: 25 * 60 + 22,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['God of War'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '20',
                startTime: 25 * 60 + 22 + 1,
                type: 'results',
                resultsFor: '19'
            },
            {
                id: '21',
                startTime: 26 * 60 + 17,
                endTime: 26 * 60 + 34,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Tetris Effect'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '22',
                startTime: 26 * 60 + 34 + 1,
                type: 'results',
                resultsFor: '21'
            },
            {
                id: '23',
                startTime: 27 * 60 + 22,
                endTime: 27 * 60 + 37,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['NieR: Automata'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '24',
                startTime: 27 * 60 + 37 + 1,
                type: 'results',
                resultsFor: '23'
            },
            {
                id: '25',
                startTime: 28 * 60 + 44,
                endTime: 29 * 60 + 19,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Bioshock'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '26',
                startTime: 29 * 60 + 19 + 1,
                type: 'results',
                resultsFor: '25'
            },
            {
                id: '27',
                startTime: 29 * 60 + 56,
                endTime: 30 * 60 + 16,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Batman: Arkham Asylum'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '28',
                startTime: 30 * 60 + 16 + 1,
                type: 'results',
                resultsFor: '27'
            },
            {
                id: '29',
                startTime: 31 * 60 + 41,
                endTime: 32 * 60 + 15,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Outer Wilds'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '30',
                startTime: 32 * 60 + 15 + 1,
                type: 'results',
                resultsFor: '29'
            },
            {
                id: '31',
                startTime: 33 * 60 + 0,
                endTime: 33 * 60 + 21,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Journey'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '32',
                startTime: 33 * 60 + 21 + 1,
                type: 'results',
                resultsFor: '31'
            },
            {
                id: '33',
                startTime: 35 * 60 + 2,
                endTime: 35 * 60 + 50,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: [
                    'Vampire: The Masquerade – Bloodlines',
                    'Vampire: The Masquerade'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '34',
                startTime: 35 * 60 + 50 + 1,
                type: 'results',
                resultsFor: '33'
            },
            {
                id: '35',
                startTime: 36 * 60 + 22,
                endTime: 36 * 60 + 46,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: [
                    'Metal Gear Solid 4: Guns of the Patriots',
                    'Metal Gear Solid 4'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '36',
                startTime: 36 * 60 + 46 + 1,
                type: 'results',
                resultsFor: '35'
            },
            {
                id: '37',
                startTime: 37 * 60 + 35,
                endTime: 38 * 60 + 3,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['The Last of Us'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '38',
                startTime: 38 * 60 + 3 + 1,
                type: 'results',
                resultsFor: '37'
            },
            {
                id: '39',
                startTime: 39 * 60 + 6,
                endTime: 39 * 60 + 21,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Wii Sports'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '40',
                startTime: 39 * 60 + 21 + 1,
                type: 'results',
                resultsFor: '39'
            },
            {
                id: '41',
                startTime: 40 * 60 + 13,
                endTime: 40 * 60 + 44,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Everwild'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '42',
                startTime: 40 * 60 + 44 + 1,
                type: 'results',
                resultsFor: '41'
            },
            {
                id: '43',
                startTime: 42 * 60 + 3,
                endTime: 42 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Sonic The Hedgehog 2', 'Sonic 2'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '44',
                startTime: 42 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '43'
            },
            {
                id: '45',
                startTime: 43 * 60 + 41,
                endTime: 43 * 60 + 53,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: [
                    'The World Ends with You: Final Remix',
                    'The World Ends With You'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '46',
                startTime: 43 * 60 + 53 + 1,
                type: 'results',
                resultsFor: '45'
            },
            {
                id: '47',
                startTime: 44 * 60 + 54,
                endTime: 45 * 60 + 7,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Fallout 4'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '48',
                startTime: 45 * 60 + 7 + 1,
                type: 'results',
                resultsFor: '47'
            },
            {
                id: '49',
                startTime: 47 * 60 + 4,
                endTime: 47 * 60 + 24,
                pause: true,
                type: 'stringCompare',
                question: 'Zoom Shot: Name the Game',
                acceptableAnswers: ['Final Fantasy 7', 'Final Fantasy VII'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '50',
                startTime: 47 * 60 + 24 + 1,
                type: 'results',
                resultsFor: '49'
            },
            {
                id: '51',
                startTime: 52 * 60 + 23,
                endTime: 53 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Game',
                acceptableAnswers: ['Legend of Zelda: Link To The Past'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '52',
                startTime: 53 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '51'
            },
            {
                id: '53',
                startTime: 54 * 60 + 20,
                endTime: 55 * 60 + 19,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Character and the Game',
                acceptableAnswers: [
                    'Falco Star Fox',
                    'Falco Lombardi Star Fox',
                    'Star Fox Falco',
                    'Star Fox Falco Lombardi'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '54',
                startTime: 55 * 60 + 19 + 1,
                type: 'results',
                resultsFor: '53'
            },
            {
                id: '55',
                startTime: 56 * 60 + 14,
                endTime: 56 * 60 + 29,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Character',
                acceptableAnswers: ['Whomp'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '56',
                startTime: 56 * 60 + 29 + 1,
                type: 'results',
                resultsFor: '55'
            },
            {
                id: '57',
                startTime: 57 * 60 + 24,
                endTime: 57 * 60 + 40,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Character',
                acceptableAnswers: ['E Honda'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '58',
                startTime: 57 * 60 + 40 + 1,
                type: 'results',
                resultsFor: '57'
            },
            {
                id: '59',
                startTime: 58 * 60 + 30,
                endTime: 58 * 60 + 48,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Game',
                acceptableAnswers: ['Resident Evil 4'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '60',
                startTime: 58 * 60 + 48 + 1,
                type: 'results',
                resultsFor: '59'
            },
            {
                id: '61',
                startTime: 59 * 60 + 24,
                endTime: 59 * 60 + 36,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Game',
                acceptableAnswers: ['Altered Beast'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '62',
                startTime: 59 * 60 + 36 + 1,
                type: 'results',
                resultsFor: '61'
            },
            {
                id: '63',
                startTime: 60 * 60 + 22,
                endTime: 60 * 60 + 37,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Character and Series',
                acceptableAnswers: ['Axel Twisted Metal', 'Twisted Metal Axel'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '64',
                startTime: 60 * 60 + 37 + 1,
                type: 'results',
                resultsFor: '63'
            },
            {
                id: '65',
                startTime: 61 * 60 + 53,
                endTime: 63 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Song',
                acceptableAnswers: ['Bloody Tears'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '66',
                startTime: 63 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '65'
            },
            {
                id: '67',
                startTime: 64 * 60 + 8,
                endTime: 64 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Song',
                acceptableAnswers: ['Song of Storms'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '68',
                startTime: 64 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '67'
            },
            {
                id: '69',
                startTime: 65 * 60 + 12,
                endTime: 65 * 60 + 30,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Game',
                acceptableAnswers: ['Punch Out'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '70',
                startTime: 65 * 60 + 30 + 1,
                type: 'results',
                resultsFor: '69'
            },
            {
                id: '71',
                startTime: 66 * 60 + 14,
                endTime: 66 * 60 + 19,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Series',
                acceptableAnswers: ['Metal Gear Solid'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '72',
                startTime: 66 * 60 + 19 + 1,
                type: 'results',
                resultsFor: '71'
            },
            {
                id: '73',
                startTime: 67 * 60 + 3,
                endTime: 67 * 60 + 28,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name just the Game',
                acceptableAnswers: ['Super Mario Sunshine'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '74',
                startTime: 67 * 60 + 28 + 1,
                type: 'results',
                resultsFor: '73'
            },
            {
                id: '75',
                startTime: 68 * 60 + 0,
                endTime: 68 * 60 + 21,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name just the Game',
                acceptableAnswers: ['WWF No Mercy'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '76',
                startTime: 68 * 60 + 21 + 1,
                type: 'results',
                resultsFor: '75'
            },
            {
                id: '77',
                startTime: 69 * 60 + 0,
                endTime: 69 * 60 + 45,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name the Series',
                acceptableAnswers: ['Tetris'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '78',
                startTime: 69 * 60 + 45 + 1,
                type: 'results',
                resultsFor: '77'
            },
            {
                id: '79',
                startTime: 70 * 60 + 36,
                endTime: 71 * 60 + 20,
                pause: true,
                type: 'stringCompare',
                question: 'The Jukebox: Name Just the Game',
                acceptableAnswers: ['Super Mario 64'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '80',
                startTime: 71 * 60 + 20 + 1,
                type: 'results',
                resultsFor: '79'
            },
            {
                id: '81',
                startTime: 73 * 60 + 19,
                endTime: 73 * 60 + 31,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Mass Effect 3'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '82',
                startTime: 73 * 60 + 31 + 1,
                type: 'results',
                resultsFor: '81'
            },
            {
                id: '83',
                startTime: 74 * 60 + 11,
                endTime: 74 * 60 + 25,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Uncharted 4'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '84',
                startTime: 74 * 60 + 25 + 1,
                type: 'results',
                resultsFor: '83'
            },
            {
                id: '85',
                startTime: 75 * 60 + 8,
                endTime: 75 * 60 + 20,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Dragon Age: Inquisition'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '86',
                startTime: 75 * 60 + 20 + 1,
                type: 'results',
                resultsFor: '85'
            },
            {
                id: '87',
                startTime: 76 * 60 + 2,
                endTime: 76 * 60 + 14,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Bioshock Infinite'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '88',
                startTime: 76 * 60 + 14 + 1,
                type: 'results',
                resultsFor: '87'
            },
            {
                id: '89',
                startTime: 77 * 60 + 0,
                endTime: 77 * 60 + 10,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ["Assassin's Creed Revelations"],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '90',
                startTime: 77 * 60 + 10 + 1,
                type: 'results',
                resultsFor: '89'
            },
            {
                id: '91',
                startTime: 77 * 60 + 52,
                endTime: 78 * 60 + 1,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Halo 5'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '92',
                startTime: 78 * 60 + 1 + 1,
                type: 'results',
                resultsFor: '91'
            },
            {
                id: '93',
                startTime: 78 * 60 + 44,
                endTime: 79 * 60 + 27,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: [
                    "Tom Clancy's Rainbow 6: Patriots",
                    'Rainbow 6: Patriots',
                    'Rainbow Six: Patriots'
                ],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '94',
                startTime: 79 * 60 + 27 + 1,
                type: 'results',
                resultsFor: '93'
            },
            {
                id: '95',
                startTime: 80 * 60 + 16,
                endTime: 80 * 60 + 40,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Project Athia', 'Forspoken'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '96',
                startTime: 80 * 60 + 40 + 1,
                type: 'results',
                resultsFor: '95'
            },
            {
                id: '97',
                startTime: 81 * 60 + 26,
                endTime: 82 * 60 + 8,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Deep Down'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '98',
                startTime: 82 * 60 + 8 + 1,
                type: 'results',
                resultsFor: '97'
            },
            {
                id: '99',
                startTime: 82 * 60 + 52,
                endTime: 83 * 60 + 11,
                pause: true,
                type: 'stringCompare',
                question: 'Cinematic Reveal Trailer Park: Name the Game',
                acceptableAnswers: ['Detroit: Become Human'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '100',
                startTime: 83 * 60 + 11 + 1,
                type: 'results',
                resultsFor: '99'
            },
            {
                id: '101',
                startTime: 85 * 60 + 10,
                endTime: 86 * 60 + 1,
                pause: true,
                type: 'stringCompare',
                question: 'Cover Storytime: Name the Game',
                acceptableAnswers: ["Army of Two: The Devil's Cartel"],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '102',
                startTime: 86 * 60 + 1 + 1,
                type: 'results',
                resultsFor: '101'
            },
            {
                id: '103',
                startTime: 87 * 60 + 15,
                endTime: 88 * 60 + 0,
                pause: true,
                type: 'stringCompare',
                question: 'Cover Storytime: Name the Game',
                acceptableAnswers: ['Fortnite'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '104',
                startTime: 88 * 60 + 0 + 1,
                type: 'results',
                resultsFor: '103'
            },
            {
                id: '105',
                startTime: 88 * 60 + 51,
                endTime: 89 * 60 + 15,
                pause: true,
                type: 'stringCompare',
                question: 'Cover Storytime: Name the Game',
                acceptableAnswers: ["Hellblade: Senua's Sacrifice", 'Hellblade'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '106',
                startTime: 89 * 60 + 15 + 1,
                type: 'results',
                resultsFor: '105'
            },
            {
                id: '107',
                startTime: 90 * 60 + 7,
                endTime: 90 * 60 + 38,
                pause: true,
                type: 'stringCompare',
                question: 'Cover Storytime: Name the Game',
                acceptableAnswers: ['Dishonored'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '108',
                startTime: 90 * 60 + 38 + 1,
                type: 'results',
                resultsFor: '107'
            },
            {
                id: '109',
                startTime: 91 * 60 + 14,
                endTime: 91 * 60 + 55,
                pause: true,
                type: 'stringCompare',
                question: 'Cover Storytime: Name the Game',
                acceptableAnswers: ['Fuse'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '110',
                startTime: 91 * 60 + 55 + 1,
                type: 'results',
                resultsFor: '109'
            },
            {
                id: '111',
                startTime: 94 * 60 + 20,
                endTime: 95 * 60 + 22,
                pause: true,
                type: 'stringCompare',
                question: 'Game Case Trivia: Name the Game',
                acceptableAnswers: ['Crash Bandicoot', 'Crash'],
                points: 20,
                threshold: 0.9,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '112',
                startTime: 95 * 60 + 22 + 1,
                type: 'results',
                resultsFor: '111'
            }
        ]
    },
    'dirty-laundry-s2e1': {
        series: shows['Dirty Laundry'],
        title: 'Who Committed Libel Against Reese Witherspoon?',
        description:
            'Vic, Raphael, Ryan, and Carolyn drink beachcombers while pestering Lily for points.',
        episode: 'dirty-laundry-s2e1',
        premiereDate: '2023-02-01',
        releaseDate: '2024-11-06',
        introMusic: { url: 'https://www.youtube.com/watch?v=mXxiZ6KQPJU&ab_channel=EpidemicTrapBeats', startTime: 0, endTime: 155, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=mXxiZ6KQPJU&ab_channel=EpidemicTrapBeats', startTime: 0, endTime: 155, source: 'youtube' },
        videoUrl: 'https://www.youtube.com/watch?v=7MbEyGRooBU',
        videoPreview: 'https://i3.ytimg.com/vi/7MbEyGRooBU/maxresdefault.jpg',
        startTime: 0,
        endTime: 41 * 60 + 22,
        totalPrompts: 11,
        events: [
            {
                id: '1',
                startTime: 0 * 60 + 0,
                endTime: 1 * 60 + 0,
                type: 'multiple',
                pause: false,
                question: 'Call your shot! Who wins this episode of "Dirty Laundry"?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page'
                ],
                acceptableAnswers: [1, 2],
                displayAnswer:
                    "B and C) It's a tie between Ryan Creamer and Raphael Chestang",
                points: 20
            },
            {
                id: '2',
                startTime: 1 * 60 + 24,
                endTime: 3 * 60 + 14,
                type: 'multiple',
                pause: true,
                question: 'Who pissed their pants, on purpose, on a first date?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 1,
                points: 4
            },
            {
                id: '3',
                startTime: 3 * 60 + 22,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '10',
                startTime: 5 * 60 + 9,
                endTime: 6 * 60 + 52,
                type: 'multiple',
                pause: true,
                question:
                    'Who had sex with someone the night that person signed their divorce papers?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 3,
                points: 4
            },
            {
                id: '11',
                startTime: 7 * 60 + 0,
                type: 'results',
                resultsFor: '10'
            },
            {
                id: '4',
                startTime: 8 * 60 + 53,
                endTime: 10 * 60 + 40,
                type: 'multiple',
                pause: true,
                question: 'Who nearly got shot while impersonating a cop?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 2,
                points: 4
            },
            {
                id: '5',
                startTime: 10 * 60 + 48,
                type: 'results',
                resultsFor: '4'
            },
            {
                id: '6',
                startTime: 13 * 60 + 40,
                endTime: 14 * 60 + 46,
                type: 'multiple',
                pause: true,
                question:
                    'Who got trapped in an amusement park in the middle of the night with a escaped inmate?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 0,
                points: 4
            },
            {
                id: '7',
                startTime: 14 * 60 + 47,
                type: 'results',
                resultsFor: '6'
            },
            {
                id: '8',
                startTime: 17 * 60 + 11,
                endTime: 18 * 60 + 46,
                type: 'multiple',
                pause: true,
                question:
                    "Have you been keeping Score? Who's currently in first place?",
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page'
                ],
                answer: 1,
                points: 4
            },
            {
                id: '9',
                startTime: 19 * 60 + 8,
                type: 'results',
                resultsFor: '8'
            },
            {
                id: '12',
                startTime: 19 * 60 + 21,
                endTime: 21 * 60 + 44,
                type: 'multiple',
                pause: true,
                question: 'Who made a hamster cum?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 4,
                points: 4
            },
            {
                id: '13',
                startTime: 21 * 60 + 55,
                type: 'results',
                resultsFor: '12'
            },
            {
                id: '14',
                startTime: 23 * 60 + 25,
                endTime: 25 * 60 + 4,
                type: 'multiple',
                pause: true,
                question: 'Who committed libel against Resse Witherspoon?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 2,
                points: 4
            },
            {
                id: '15',
                startTime: 25 * 60 + 13,
                type: 'results',
                resultsFor: '14'
            },
            {
                id: '16',
                startTime: 26 * 60 + 58,
                endTime: 28 * 60 + 7,
                type: 'multiple',
                pause: true,
                question: "Who burned somebody's eye after a profession of love?",
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 3,
                points: 4
            },
            {
                id: '17',
                startTime: 28 * 60 + 15,
                type: 'results',
                resultsFor: '16'
            },
            {
                id: '18',
                startTime: 31 * 60 + 9,
                endTime: 33 * 60 + 1,
                type: 'multiple',
                pause: true,
                question:
                    "Who had their driver's license photo taken while still in their Halloween costume?",
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 1,
                points: 4
            },
            {
                id: '19',
                startTime: 33 * 60 + 14,
                type: 'results',
                resultsFor: '18'
            },
            {
                id: '20',
                startTime: 34 * 60 + 53,
                endTime: 36 * 60 + 53,
                type: 'multiple',
                pause: true,
                question: 'Who had a bomb squad called because of them?',
                choices: [
                    'Vic Michaelis',
                    'Ryan Creamer',
                    'Raphael Chestang',
                    'Carolyn Page',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 0,
                points: 4
            },
            {
                id: '21',
                startTime: 37 * 60 + 2,
                type: 'results',
                resultsFor: '18'
            },
            {
                id: '22',
                startTime: 39 * 60 + 9,
                type: 'results',
                resultsFor: '1'
            },
            {
                id: '23',
                startTime: 40 * 60 + 9,
                type: 'finalResults',
                resultsFor: '1'
            }
        ]
    },
    'um-actually-s1e5': {
        title: 'Animalities, Maple Street Monsters, Mutagen Ooze',
        series: shows['Um Actually'],
        description:
            'Brennan Lee Mulligan, Siobhan Thompson, and Adam Conover name dragons and parse nonlinear timelines.',
        episode: 'um-actually-s1e5',
        premiereDate: '2018-10-11',
        releaseDate: '2024-11-06',
        introMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=bKN123V3w9Q&ab_channel=RadioNight-Topic', startTime: 0, endTime: 123, source: 'youtube' },
        videoUrl: 'https://youtu.be/J8ZuoNkkt88?si=AQjNr1d1_dVTeoZe',
        videoPreview: 'https://i3.ytimg.com/vi/J8ZuoNkkt88/maxresdefault.jpg',
        startTime: 0,
        endTime: 23 * 60 + 9,
        totalPrompts: 13,
        events: [
            {
                id: '2',
                startTime: 1 * 60 + 40,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: ['High Elves', 'Blood Elves', 'Wood Elves', 'Dark Elves'],
                answer: 1,
                displayAnswer: 'B) Blood Elves are from Warcraft',
                points: 5
            },
            {
                id: '3',
                startTime: 1 * 60 + 50,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '2',
                startTime: 3 * 60 + 3,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    '...is populated by dozens of animal-human hybrids...',
                    '...created by coming into contact with mutagenic ooze.',
                    'This includes the turtles themselves...',
                    '...mutated alligator Leatherhead...',
                    '... human-fly hybrid Baxter Stockman.'
                ],
                answer: 4,
                displayAnswer:
                    "E) Um, actually, Baxter Stockman's mutation wasn't caused by the mutagenic ooze.",
                points: 5
            },
            {
                id: '3',
                startTime: 3 * 60 + 25,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '4',
                startTime: 4 * 60 + 18,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    "One of the series' most famous episodes...",
                    '..."The Monsters are Due on Maple Street"...',
                    "...doesn't actually feature monsters or paranormal creatures of any kind...",
                    '...The true monsters are the people of Maple Street giving in to paranoid violence.'
                ],
                answer: 2,
                displayAnswer:
                    'C) Um, actually, it is revealed at the end of the episode that aliens were manipulating electronic devices.',
                points: 5
            },
            {
                id: '5',
                startTime: 4 * 60 + 25,
                type: 'quickResults',
                resultsFor: '4'
            },
            {
                id: '6',
                startTime: 4 * 60 + 49,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    'In the Phillip K. Dick novel "Blade Runner"...',
                    '...Rick Deckard, uses a Voight-Kampff machine...',
                    '...to determine if a suspect is truly human by measuring...'
                ],
                answer: 0,
                displayAnswer:
                    'A) Um, actually, the novel is titled "Do Androids Dream of Electric Sheep?".',
                points: 5
            },
            {
                id: '7',
                startTime: 4 * 60 + 54,
                type: 'results',
                resultsFor: '6'
            },
            {
                id: '8',
                startTime: 6 * 60 + 8,
                type: 'multiple',
                pause: true,
                question: 'Which of these movies is not addapted from a comic?',
                choices: [
                    'Atomic Blonde',
                    'A History of Violence',
                    'The Fifth Element',
                    'MonkeyBone',
                    'Weird Science',
                    'Road to Perdition'
                ],
                answer: 1,
                displayAnswer: 'B) The Fifth Element',
                points: 5
            },
            {
                id: '9',
                startTime: 6 * 60 + 25,
                type: 'results',
                resultsFor: '8'
            },
            {
                id: '12',
                startTime: 8 * 60 + 23,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    'Professor X',
                    'Crusader X',
                    'Stacy X',
                    'X-Man',
                    'X-Treme',
                    'Mage-X',
                    'X-23'
                ],
                answer: 5,
                displayAnswer: 'F) Um, actually, Mage-X is not a real X-Men.',
                points: 5
            },
            {
                id: '13',
                startTime: 8 * 60 + 54,
                type: 'results',
                resultsFor: '12'
            },
            {
                id: '14',
                startTime: 10 * 60 + 27,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    "In the first book of Terry Pratchett's Discworld series...",
                    '..."The Colour of Magic"...',
                    '...readers learn that the color of pure magic is octarine...',
                    '... a color visible only to wizards.'
                ],
                answer: 3,
                displayAnswer: 'd) Um, actually, cats can also see octarine.',
                points: 5
            },
            {
                id: '15',
                startTime: 11 * 60 + 0,
                type: 'results',
                resultsFor: '14'
            },
            {
                id: '16',
                startTime: 11 * 60 + 36,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    "Otto's Irresistible Dance which makes enemies dance uncontrollably...",
                    "Quincy's Enchanting Gourmet, which lets you imbue food with magic...",
                    '...and Guise of the Yak Man, which makes you appear to be a yak man.'
                ],
                answer: 1,
                displayAnswer:
                    "B) Um, actually, Quincy's Enchanting Gourmet is a spell dedicated to cooking and cleaning up the kitchen afterwards.",
                points: 5
            },
            {
                id: '17',
                startTime: 11 * 60 + 48,
                type: 'results',
                resultsFor: '16'
            },
            {
                id: '18',
                startTime: 13 * 60 + 30,
                type: 'multiple',
                pause: true,
                question:
                    'Which of these movies does not have a time travel machine or device?',
                choices: [
                    'Top Left',
                    'Top Middle',
                    'Top Right',
                    'Bottom Left',
                    'Bottom Middle',
                    'Bottom Right'
                ],
                answer: 4,
                displayAnswer: 'E) Bottom Middle, "Groundhog Day" has no time machine.',
                points: 5
            },
            {
                id: '19',
                startTime: 15 * 60 + 1,
                type: 'results',
                resultsFor: '18'
            },
            {
                id: '20',
                startTime: 15 * 60 + 51,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    'As a powerful Sith Lord, Darth Vader...',
                    '... can harness power of the dark side of the Force...',
                    '... to conjure Force lightning,...',
                    ' and use the power of the Force for evil...',
                    ' means like when he uses telekinesis to choke adversaries.'
                ],
                answer: 2,
                displayAnswer:
                    'C) Um, actually, Darth Vader cannot cast Force lightning because he has mechanical limbs.',
                points: 5
            },
            {
                id: '21',
                startTime: 15 * 60 + 55,
                type: 'results',
                resultsFor: '20'
            },
            {
                id: '22',
                startTime: 17 * 60 + 11,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    '...characters can perform "Animalities" as a finisher,...',
                    '...in which the character temporarily transforms into an animal...',
                    '...Nightwolf transforms into a wolf,...',
                    'Scorpion transforms into a scorpion,...',
                    'and Johnny Cage transforms into a kangaroo.'
                ],
                answer: 3,
                displayAnswer: 'C) Um, actually, Scorpion transforms into a penguin.',
                points: 5
            },
            {
                id: '23',
                startTime: 17 * 60 + 27,
                type: 'results',
                resultsFor: '22'
            },
            {
                id: '24',
                startTime: 18 * 60 + 19,
                type: 'multiple',
                pause: true,
                question:
                    'Which row of these dragons can you find a man? I mean, he was a dragon man. Or, maybe he was just a dragon. But he was still...',
                choices: ['First Row', 'Second Row', 'Third Row', 'Fourth Row'],
                answer: 1,
                displayAnswer: 'B) TROGDOR!',
                points: 5
            },
            {
                id: '25',
                startTime: 18 * 60 + 43,
                type: 'results',
                resultsFor: '24'
            },
            {
                id: '26',
                startTime: 22 * 60 + 12,
                type: 'multiple',
                pause: true,
                question: 'Which part of the statement is wrong?',
                choices: [
                    "...world's longuest border ,...",
                    '...Prime Minister is Justin Trudeau...',
                    '...their capital city is Toronto,...',
                    '...their official language is both English and French.'
                ],
                answer: 2,
                displayAnswer: 'C) Um, actually, The capital city of Canada is Ottawa.',
                points: 5
            },
            {
                id: '27',
                startTime: 22 * 60 + 36,
                type: 'quickResults',
                resultsFor: '26'
            },
            {
                id: '21',
                startTime: 22 * 60 + 48,
                type: 'finalResults',
                resultsFor: '1'
            }
        ]
    },

    'dirty-laundry-s1e1': {
        series: shows['Dirty Laundry'],
        title: 'Who Shot a Softcore Porn?',
        description:
            'Sam Reich, Katie Marovitch, Jacob Wysocki, and Raphael Chestang kick off Dirty Laundry with a bang.',
        episode: 'dirty-laundry-s1e1',
        premiereDate: '2022-08-08',
        releaseDate: '2024-11-06',
        introMusic: { url: 'https://www.youtube.com/watch?v=mXxiZ6KQPJU&ab_channel=EpidemicTrapBeats', startTime: 0, endTime: 155, source: 'youtube' },
        promptMusic: { url: 'https://www.youtube.com/watch?v=mXxiZ6KQPJU&ab_channel=EpidemicTrapBeats', startTime: 0, endTime: 155, source: 'youtube' },
        videoUrl: 'https://youtu.be/xzhhbvUIWEs?si=od4ks_Du1LTXrwOx',
        videoPreview: 'https://i3.ytimg.com/vi/xzhhbvUIWEs/maxresdefault.jpg',
        startTime: 0,
        endTime: 34 * 60 + 26,
        totalPrompts: 10,
        events: [
            {
                id: '1',
                startTime: 0 * 60 + 0,
                endTime: 1 * 60 + 0,
                type: 'multiple',
                pause: false,
                question: 'Call your shot! Who wins this episode of "Dirty Laundry"?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki'
                ],
                answer: 1,
                points: 20
            },
            {
                id: '2',
                startTime: 1 * 60 + 23,
                endTime: 3 * 60 + 34,
                type: 'multiple',
                pause: true,
                question: 'Who participated in a four-way kiss?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 1,
                points: 4
            },
            {
                id: '3',
                startTime: 3 * 60 + 44,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '2',
                startTime: 4 * 60 + 28,
                endTime: 6 * 60 + 54,
                type: 'multiple',
                pause: true,
                question: 'Who had such bad gas they had to go to the hospital?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 2,
                points: 4
            },
            {
                id: '3',
                startTime: 7 * 60 + 5,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '4',
                startTime: 8 * 60 + 22,
                endTime: 9 * 60 + 54,
                type: 'multiple',
                pause: true,
                question: 'Who got stiches in the pit of a punk rock show?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 3,
                points: 4
            },
            {
                id: '5',
                startTime: 10 * 60 + 2,
                type: 'results',
                resultsFor: '4'
            },
            {
                id: '6',
                startTime: 11 * 60 + 30,
                endTime: 13 * 60 + 16,
                type: 'multiple',
                pause: true,
                question: 'Who almost died from a nosebleed?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 5,
                points: 4
            },
            {
                id: '7',
                startTime: 13 * 60 + 24,
                type: 'results',
                resultsFor: '6'
            },
            {
                id: '8',
                startTime: 14 * 60 + 32,
                endTime: 15 * 60 + 56,
                type: 'multiple',
                pause: true,
                question:
                    "Have you been keeping Score? Who's currently in first place?",
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki'
                ],
                answer: 0,
                points: 4
            },
            {
                id: '9',
                startTime: 16 * 60 + 0,
                type: 'results',
                resultsFor: '8'
            },
            {
                id: '12',
                startTime: 16 * 60 + 20,
                endTime: 19 * 60 + 20,
                type: 'multiple',
                pause: true,
                question: 'Who accidentally dropped and killed a baby duck?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 1,
                points: 4
            },
            {
                id: '13',
                startTime: 19 * 60 + 10,
                type: 'results',
                resultsFor: '12'
            },
            {
                id: '14',
                startTime: 21 * 60 + 40,
                endTime: 23 * 60 + 8,
                type: 'multiple',
                pause: true,
                question: 'Who shot a softcore porn?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 0,
                points: 4
            },
            {
                id: '15',
                startTime: 23 * 60 + 17,
                type: 'results',
                resultsFor: '14'
            },
            {
                id: '16',
                startTime: 24 * 60 + 8,
                endTime: 25 * 60 + 50,
                type: 'multiple',
                pause: true,
                question: 'Who smoked opium by accident?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 3,
                points: 4
            },
            {
                id: '17',
                startTime: 25 * 60 + 58,
                type: 'results',
                resultsFor: '16'
            },
            {
                id: '18',
                startTime: 26 * 60 + 50,
                endTime: 30 * 60 + 35,
                type: 'multiple',
                pause: true,
                question: 'Who puked on a popstar?',
                choices: [
                    'Sam Reich',
                    'Katie Marovitch',
                    'Raphael Chestang',
                    'Jacob Wysocki',
                    'Lily Du',
                    "Grant O'Brien"
                ],
                answer: 2,
                points: 4
            },
            {
                id: '19',
                startTime: 30 * 60 + 44,
                type: 'results',
                resultsFor: '18'
            },
            {
                id: '20',
                startTime: 32 * 60 + 0,
                type: 'results',
                resultsFor: '1'
            },
            {
                id: '21',
                startTime: 33 * 60 + 12,
                type: 'finalResults',
                resultsFor: '1'
            }
        ]
    },
    'arcade-pit-giant-bomb-e13': {
        series: shows['Arcade Pit'],
        title: 'Arcade Pit: Giant Bomb #13',
        description: 'Team Young, Dumb, and Full of Fun vs Team Big Sexy’s Ravioli',
        episode: 'arcade-pit-giant-bomb-e13',
        premiereDate: '2022-07-22',
        releaseDate: '2024-11-06',
        introMusic: { url: 'https://www.youtube.com/watch?v=AgIuO71I818&ab_channel=TieTuesdayStreamArchives', startTime: 0, endTime: 999, source: 'youtube' },
        promptMusic: { url: '/assets/audio/playalong/mtvremote.mp3', startTime: 0, endTime: 999, source: 'mp3' },
        videoUrl:
            'https://www.youtube.com/watch?v=3zPj_V_Tj74&ab_channel=GiantBomb',
        videoPreview: 'https://i3.ytimg.com/vi/3zPj_V_Tj74/maxresdefault.jpg',
        startTime: 0,
        endTime: 90 * 60 + 11,
        totalPrompts: 26,
        events: [
            {
                id: '1',
                startTime: 0 * 60 + 0,
                endTime: 1 * 60 + 0,
                type: 'multiple',
                pause: false,
                question: 'Call your shot! Which team do you think wins this episode of Arcade Pit?',
                stringQuestion:
                    'Call your shot! Which team do you think wins this episode of Arcade Pit?',
                choices: ['Yellow Team', 'Blue Team'],
                answer: 1,
                points: 20
            },
            {
                id: '2',
                startTime: 1 * 60 + 30,
                type: 'multiple',
                pause: true,
                question: 'Who Will Win The First Challenge?',
                choices: ['Abby', 'Ben', 'Dan', 'Maffew'],
                points: 30,
                answer: 3
            },
            {
                id: '3',
                startTime: 3 * 60 + 4,
                type: 'results',
                resultsFor: '2'
            },
            {
                id: '4',
                startTime: 4 * 60 + 51,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: ['Katana Zero'],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '6',
                startTime: 5 * 60 + 9,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: ['Alisia Dragoon'],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '8',
                startTime: 5 * 60 + 23,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: ['Chakan: The Forever Man', 'Chakan'],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '9',
                startTime: 5 * 60 + 30,
                type: 'results',
                resultsFor: '8'
            },
            {
                id: '5',
                startTime: 6 * 60 + 17,
                type: 'results',
                resultsFor: '4'
            },
            {
                id: '7',
                startTime: 6 * 60 + 47,
                type: 'results',
                resultsFor: '6'
            },
            {
                id: '10',
                startTime: 8 * 60 + 40,
                type: 'multiple',
                pause: true,
                question: 'How does Abby try to bully Dan?',
                choices: [
                    'Call Him Names',
                    'Give Him A Swirly',
                    'Give Him A Wedgie',
                    'Prank Call Him'
                ],
                points: 30,
                answer: 1,
                displayAnswer:
                    'B) "Do you have a toilet nearby? We need to give you a swirly" -Abby'
            },
            {
                id: '11',
                startTime: 8 * 60 + 42,
                type: 'results',
                resultsFor: '10'
            },
            {
                id: '12',
                startTime: 14 * 60 + 46,
                type: 'multiple',
                pause: true,
                question:
                    'Hades: in order to unlock weapons you must spend Cthnoic keys. However, the last weapon, the Adamant Rail has another unlocked condition what is it',
                choices: [
                    'Defeat the Lernian Hydra.',
                    'Die ten times.',
                    'Unlock all other weapons.',
                    'Find it in Elysium'
                ],
                points: 15,
                answer: 2
            },
            {
                id: '13',
                startTime: 14 * 60 + 49,
                type: 'results',
                resultsFor: '12'
            },
            {
                id: '14',
                startTime: 15 * 60 + 31,
                type: 'multiple',
                pause: true,
                question: 'Mario Party 7: What board can the "Bandit" Orb be used on?',
                choices: [
                    'Windmillville',
                    "Koopa's Tycoon Town",
                    'Neon Heights',
                    'Pyramid Park'
                ],
                points: 15,
                answer: 0
            },
            {
                id: '15',
                startTime: 15 * 60 + 43,
                type: 'results',
                resultsFor: '14'
            },
            {
                id: '16',
                startTime: 16 * 60 + 36,
                endTime: 17 * 60 + 1,
                type: 'numberCurve',
                pause: true,
                question:
                    'How many Quizzler Blitz questions (out of 5) will Yellow Team get correct?',
                answer: 1,
                displayAnswer: '1',
                points: 25,
                stepAmount: 1,
                stepDrop: 5
            },
            {
                id: '17',
                startTime: 18 * 60 + 4,
                type: 'results',
                resultsFor: '16'
            },
            {
                id: '18',
                startTime: 20 * 60 + 49,
                endTime: 21 * 60 + 0,
                type: 'multiple',
                pause: true,
                question:
                    'True or False: Due to a Glitch, Dan wins the challenge by default',
                choices: ['True', 'False'],
                answer: 1,
                displayAnswer:
                    "B) False, Dan just didn't do enough damage to the first stage of the boss, but Smight still gave them their turn back",
                points: 10
            },
            {
                id: '19',
                startTime: 23 * 60 + 42,
                type: 'results',
                resultsFor: '18'
            },
            {
                id: '20',
                startTime: 25 * 60 + 40,
                endTime: 25 * 60 + 56,
                type: 'stringCompare',
                pause: true,
                question: 'What Game Does This Song Come From?',
                acceptableAnswers: ['Mega Man X', 'Megaman X'],
                points: 30,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 5
            },
            {
                id: '21',
                startTime: 26 * 60 + 4,
                type: 'results',
                resultsFor: '20'
            },
            {
                id: '22',
                startTime: 28 * 60 + 15,
                type: 'multiple',
                pause: true,
                question:
                    'True or False: Dan thought "Egg Whites" was the shell of an egg',
                choices: ['True', 'False'],
                answer: 0,
                points: 15
            },
            {
                id: '23',
                startTime: 28 * 60 + 29,
                type: 'results',
                resultsFor: '22'
            },
            {
                id: '24',
                startTime: 31 * 60 + 16,
                endTime: 32 * 60 + 30,
                type: 'multiple',
                pause: true,
                question: 'Which Team Wins This Challenge?',
                choices: ['Yellow Team', 'Blue Blue'],
                answer: 1,
                points: 20
            },
            {
                id: '25',
                startTime: 33 * 60 + 32,
                type: 'results',
                resultsFor: '24'
            },
            {
                id: '26',
                startTime: 35 * 60 + 25,
                endTime: 36 * 60 + 0,
                type: 'numberCurve',
                pause: true,
                question:
                    'What\'s Abby\'s Score in "Gun Nac" at the end of this challenge?',
                answer: 28810,
                displayAnswer: '28810',
                points: 20,
                stepAmount: 100,
                stepDrop: 1
            },
            {
                id: '27',
                startTime: 37 * 60 + 30,
                type: 'results',
                resultsFor: '26'
            },
            {
                id: '28',
                startTime: 38 * 60 + 41,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: ['Illusion of Gaia'],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '29',
                startTime: 38 * 60 + 42,
                type: 'quickResults',
                resultsFor: '28'
            },
            {
                id: '30',
                startTime: 38 * 60 + 52,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: ['Fallout 76'],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '31',
                startTime: 38 * 60 + 56,
                type: 'quickResults',
                resultsFor: '30'
            },
            {
                id: '32',
                startTime: 39 * 60 + 12,
                type: 'stringCompare',
                pause: true,
                question: 'Screencrap: What Game is this?',
                acceptableAnswers: [
                    'Shinning Force II',
                    'Shinning Force 2',
                    'Shinning Force Two'
                ],
                points: 10,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '33',
                startTime: 39 * 60 + 16,
                type: 'quickResults',
                resultsFor: '32'
            },
            {
                id: '330',
                startTime: 39 * 60 + 47,
                type: 'scores'
            },
            {
                id: '34',
                startTime: 42 * 60 + 45,
                type: 'multiple',
                pause: true,
                question: 'What is Cloud Wearing?',
                choices: [
                    'A Devil Costume',
                    'A Tuxedo',
                    'A Darth Vader Costume',
                    'A Trench Coat'
                ],
                points: 20,
                answer: 3,
                displayAnswer:
                    'D) "Cloud wielding three swords in a trench coat" -Smight'
            },
            {
                id: '35',
                startTime: 43 * 60 + 29,
                type: 'results',
                resultsFor: '34'
            },
            {
                id: '36',
                startTime: 44 * 60 + 42,
                endTime: 46 * 60 + 0,
                type: 'multiple',
                pause: true,
                question: 'Which team do you think wins "Relay Race"?',
                stringQuestion: 'Which team do you think wins "Relay Race"?',
                choices: ['Yellow Team', 'Blue Team'],
                answer: 1,
                points: 20
            },
            {
                id: '37',
                startTime: 49 * 60 + 40,
                type: 'results',
                resultsFor: '36'
            },
            {
                id: '34',
                startTime: 52 * 60 + 6,
                type: 'numberCurve',
                pause: true,
                question:
                    'Unsurpringly, Smight wins the challenge. How long (in seconds) does he let Dan rant about not understanding how fruit "Ripeness" works after he\'s finished the challenge?',
                points: 20,
                answer: 54,
                displayAnswer: '54 Seconds',
                stepAmount: 1,
                stepDrop: 1
            },
            {
                id: '35',
                startTime: 54 * 60 + 14,
                type: 'results',
                resultsFor: '34'
            },
            {
                id: '36',
                startTime: 55 * 60 + 52,
                type: 'multiple',
                pause: true,
                question:
                    'Slay the Spire: What does the Time Eater say when you encounter him?',
                choices: [
                    'Ah...company...',
                    'Ah...guests...',
                    'Ah...interlopers...',
                    "Ah...Where's my bib..."
                ],
                points: 15,
                answer: 0
            },
            {
                id: '37',
                startTime: 55 * 60 + 53,
                type: 'results',
                resultsFor: '36'
            },
            {
                id: '38',
                startTime: 56 * 60 + 25,
                type: 'multiple',
                pause: true,
                question:
                    "Super Mario RPG: What happens if you run up a debt too big for you to pay off at Marrymore's inn?",
                choices: [
                    "You're banned from the inn.",
                    'You get Frog Coins taken from you.',
                    "You're forced to work as a bellhop",
                    'The game crashes.'
                ],
                points: 15,
                answer: 2
            },
            {
                id: '39',
                startTime: 56 * 60 + 42,
                type: 'results',
                resultsFor: '38'
            },
            {
                id: '40',
                startTime: 60 * 60 + 20,
                type: 'stringCompare',
                pause: true,
                question: 'Who Is This?',
                acceptableAnswers: [
                    'Barret Wallace',
                    'Barret',
                    'Guy From Final Fantasy with a gun arm'
                ],
                points: 20,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '41',
                startTime: 61 * 60 + 8,
                type: 'results',
                resultsFor: '40'
            },
            {
                id: '42',
                startTime: 63 * 60 + 22,
                type: 'numberCurve',
                pause: true,
                question:
                    'How Long (In Seconds) Does It Take For Ben To Guess The Drawing?',
                answer: 27,
                displayAnswer: '27 Seconds',
                points: 20,
                stepAmount: 1,
                stepDrop: 5
            },
            {
                id: '43',
                startTime: 63 * 60 + 58,
                type: 'results',
                resultsFor: '42'
            },
            {
                id: '44',
                startTime: 66 * 60 + 51,
                type: 'numberCurve',
                pause: true,
                question:
                    'How Many Coins Does Maffew Have by the End of the Challenge?',
                answer: 130,
                displayAnswer: '130 Coins',
                points: 20,
                stepAmount: 1,
                stepDrop: 5
            },
            {
                id: '45',
                startTime: 69 * 60 + 52,
                type: 'results',
                resultsFor: '44'
            },
            {
                id: '46',
                startTime: 71 * 60 + 24,
                endTime: 72 * 60 + 10,
                type: 'stringCompare',
                pause: true,
                question: 'Sound Test: What Game is this?',
                acceptableAnswers: ['Star Fox', 'StarFox', 'Starwing'],
                points: 20,
                threshold: 0.8,
                stepAmount: 0.05,
                stepDrop: 2
            },
            {
                id: '47',
                startTime: 72 * 60 + 22,
                type: 'results',
                resultsFor: '46'
            },
            {
                id: '48',
                startTime: 74 * 60 + 55,
                endTime: 76 * 60 + 49,
                type: 'multiple',
                pause: true,
                question: 'Quad Draw: Who Got The Most Votes from the Audience?',
                choices: ['Red', 'Green', 'Yellow', 'Blue'],
                points: 40,
                answer: 3
            },
            {
                id: '49',
                startTime: 77 * 60 + 23,
                type: 'results',
                resultsFor: '48'
            },
            {
                id: '50',
                startTime: 78 * 60 + 47,
                endTime: 80 * 60 + 18,
                type: 'order',
                pause: true,
                question: 'Guess The Order The Players Will Finish In',
                choices: ['Ben', 'Abby', 'Dan', 'Maffew'],
                points: 40,
                answer: 1432,
                displayAnswer: '1432'
            },
            {
                id: '51',
                startTime: 81 * 60 + 53,
                type: 'results',
                resultsFor: '50'
            },
            {
                id: '52',
                startTime: 82 * 60 + 53,
                type: 'results',
                resultsFor: '1'
            },
            {
                id: '53',
                startTime: 83 * 60 + 53,
                type: 'finalResults',
                resultsFor: '1'
            }
        ]
    }
    // {
    //   series: 'Arcade Pit',
    //   episode: 'S1E1',
    // introMusic: { url: '/assets/audio/playalong/mtvremote.mp3', startTime: 0, endTime: 999, source: 'mp3' },
    // promptMusic: { url: '/assets/audio/playalong/mtvremote.mp3', startTime: 0, endTime: 999, source: 'mp3' },
    //   description:
    //     'Arcade Pit is a 2v2 retro console game show hosted here every Sunday night (8 Eastern).',
    //   creator: {
    //     name: 'Smight',
    //     description: 'Smight is a speedrunner and streamer',
    //     qrCode: 'https://www.twitch.tv/smight',
    //     platforms: {
    //       content: {
    //         twitch: 'smight',
    //         youtube: 'https://www.youtube.com/@smightlp/'
    //       },
    //       social: {
    //         bsky: 'smight.bsky.social',
    //         twitter: 'smight',
    //         discord: 'discord.gg/smight'
    //       },
    //       support: {
    //         patreon: 'https://www.patreon.com/smight',
    //         streamlabs: 'https://streamlabs.com/smight/tip',
    //         merch: 'https://www.designbyhumans.com/shop/Smite/'
    //       }
    //     }
    //   },

    //   videoUrl: 'https://youtu.be/FT4LHHzXJAs?si=jhhoaUdFGZNhHgUm',
    //   videoPreview: 'https://i3.ytimg.com/vi/FT4LHHzXJAs/maxresdefault.jpg',
    //   startTime: 0,
    //   endTime: 58 * 60 + 11,
    //   events: [
    //     {
    //       id: '1',
    //       startTime: 0 * 60 + 5,
    //       endTime: 2 * 60 + 5,
    //       type: 'multiple',
    //       pause: false,
    //       question: (
    //         <>
    //           Call your shot!
    //           <br />
    //           Which team do you think wins the first episode of Arcade Pit?
    //         </>
    //       ),
    //       choices: ['Yellow Team', 'Red Team'],
    //       answer: 0,
    //       displayAnswer: 'a) Yellow Team',
    //       points: 20
    //     },
    //     {
    //       id: '2',
    //       startTime: 2 * 60 + 53,
    //       type: 'numberCurve',
    //       pause: true,
    //       question:
    //         'What Is The Points Difference Between The Two Players At The End Of The Challenge?',
    //       answer: 7350,
    //       points: 20,
    //       stepAmount: 100,
    //       stepDrop: 1
    //     },
    //     {
    //       id: '3',
    //       startTime: 5 * 60,
    //       type: 'results',
    //       resultsFor: '2'
    //     },
    //     {
    //       id: '4',
    //       startTime: 8 * 60 + 12,
    //       type: 'percentageCurve',
    //       pause: true,
    //       question:
    //         "On Their Best Attempt, How Low (%) Did The Boss's health get?",
    //       answer: 0.49,
    //       displayAnswer: '49%',
    //       points: 20,
    //       stepAmount: 0.05,
    //       stepDrop: 1
    //     },
    //     {
    //       id: '5',
    //       startTime: 9 * 60 + 20,
    //       type: 'results',
    //       resultsFor: '4'
    //     },
    //     {
    //       id: '6',
    //       startTime: 11 * 60 + 18,
    //       type: 'multiple',
    //       pause: true,
    //       question:
    //         'According to Smight, What Prevented Catsworth From Completing This Challenge?',
    //       choices: [
    //         'The Boiling Pots',
    //         'Shapeshifting Enemies',
    //         'Lack of Practice',
    //         'Nothing'
    //       ],
    //       points: 30,
    //       answer: 3,
    //       displayAnswer:
    //         'D) "He didn\'t make it because he got stuck on nothing!" -Smight'
    //     },
    //     {
    //       id: '7',
    //       startTime: 13 * 60 + 26,
    //       type: 'results',
    //       resultsFor: '6'
    //     },
    //     {
    //       id: '8',
    //       startTime: 14 * 60 + 17,
    //       endTime: 15 * 60,
    //       type: 'stringCompare',
    //       pause: true,
    //       question: 'Screencrap: What Game is this?',
    //       acceptableAnswers: [
    //         "DoReMi Fantasy: Milon's DokiDoki Adventure",
    //         'DoReMi Fantasy',
    //         'DoReMi'
    //       ],
    //       points: 20,
    //       threshold: 0.8,
    //       stepAmount: 0.05,
    //       stepDrop: 2
    //     },
    //     {
    //       id: '9',
    //       startTime: 15 * 60 + 16,
    //       type: 'results',
    //       resultsFor: '8'
    //     },
    //     {
    //       id: '10',
    //       startTime: 20 * 60 + 42,
    //       type: 'numberCurve',
    //       pause: true,
    //       question: 'How Many Total Stars Were Collected Before The Buzzer?',
    //       answer: 8,
    //       displayAnswer: '8 stars',
    //       points: 20,
    //       stepAmount: 1,
    //       stepDrop: 5
    //     },
    //     {
    //       id: '11',
    //       startTime: 20 * 60 + 43,
    //       type: 'results',
    //       resultsFor: '10'
    //     },
    //     {
    //       id: '12',
    //       startTime: 24 * 60 + 52,
    //       endTime: 25 * 60 + 52,
    //       type: 'stringCompare',
    //       pause: false,
    //       question: 'Who Is Mowing The Lawn?',
    //       acceptableAnswers: ['Master Chief', 'John', 'John 117', 'John-117'],
    //       points: 20,
    //       threshold: 0.8,
    //       stepAmount: 0.05,
    //       stepDrop: 1
    //     },
    //     {
    //       id: '13',
    //       startTime: 26 * 60 + 5,
    //       type: 'results',
    //       resultsFor: '12'
    //     },
    //     {
    //       id: '14',
    //       startTime: 28 * 60 + 0,
    //       endTime: 28 * 60 + 39,
    //       type: 'stringCompare',
    //       pause: true,
    //       question: 'What Game Does This Song Come From?',
    //       acceptableAnswers: ['Aero the Acro-Bat', 'Aero', 'Aero the Acrobat'],
    //       points: 30,
    //       threshold: 0.8,
    //       stepAmount: 0.05,
    //       stepDrop: 5
    //     },
    //     {
    //       id: '15',
    //       startTime: 29 * 60 + 12,
    //       type: 'results',
    //       resultsFor: '14'
    //     },
    //     {
    //       id: '16',
    //       startTime: 31 * 60 + 12,
    //       type: 'multiple',
    //       pause: true,
    //       question: 'Devil May Cry 4: What is The Original Form of Pandora?',
    //       choices: ['Box', 'Briefcase', 'Bowgun', 'Spectral Sword'],
    //       points: 30,
    //       answer: 1,
    //       displayAnswer: 'B) Briefcase'
    //     },
    //     {
    //       id: '17',
    //       startTime: 31 * 60 + 17,
    //       type: 'results',
    //       resultsFor: '16'
    //     },
    //     {
    //       id: '18',
    //       startTime: 32 * 60 + 27,
    //       endTime: 33 * 60 + 0,
    //       type: 'stringCompare',
    //       pause: true,
    //       question: 'What Game Does This Song Come From?',
    //       acceptableAnswers: ['Primal Rage'],
    //       points: 40,
    //       threshold: 0.8,
    //       stepAmount: 0.05,
    //       stepDrop: 5
    //     },
    //     {
    //       id: '19',
    //       startTime: 33 * 60 + 35,
    //       type: 'results',
    //       resultsFor: '18'
    //     },
    //     {
    //       id: '20',
    //       startTime: 35 * 60 + 49,
    //       type: 'multiple',
    //       pause: true,
    //       question: 'What Damage Element Does The Positron Rifle Have?',
    //       choices: ['Fire', 'Holy', 'Lightning', 'Ice'],
    //       points: 40,
    //       answer: 0,
    //       displayAnswer: 'A) Fire'
    //     },
    //     {
    //       id: '21',
    //       startTime: 35 * 60 + 55,
    //       type: 'results',
    //       resultsFor: '20'
    //     },
    //     {
    //       id: '22',
    //       startTime: 37 * 60 + 10,
    //       endTime: 40 * 60 + 10,
    //       type: 'multiple',
    //       pause: false,
    //       question:
    //         'Which Of The Following Characters Have Not Been The Lead In A "Crazy Castle" Game?',
    //       choices: [
    //         'Daffy Duck',
    //         'Woody Woodpecker',
    //         'Peter Venkman',
    //         'Roger Rabbit'
    //       ],
    //       points: 20,
    //       answer: 0,
    //       displayAnswer: 'A) Daffy Duck'
    //     },
    //     {
    //       id: '23',
    //       startTime: 40 * 60 + 19,
    //       type: 'results',
    //       resultsFor: '22'
    //     },
    //     {
    //       id: '24',
    //       startTime: 42 * 60 + 25,
    //       endTime: 43 * 60 + 42,
    //       type: 'stringCompare',
    //       pause: false,
    //       question: 'What Game Did Lololo and Lalala First Appear In?',
    //       acceptableAnswers: ["Kirby's Dream Land", 'Kirby Dream Land'],
    //       points: 40,
    //       threshold: 0.8,
    //       stepAmount: 0.05,
    //       stepDrop: 5
    //     },
    //     {
    //       id: '25',
    //       startTime: 43 * 60 + 43,
    //       type: 'results',
    //       resultsFor: '24'
    //     },
    //     {
    //       id: '26',
    //       startTime: 45 * 60 + 41,
    //       type: 'multiple',
    //       pause: true,
    //       question:
    //         "Which Of The Following Grants A Power In Mickey's Magical Quest?",
    //       choices: [
    //         'A Turban',
    //         'A Vacuum Cleaner',
    //         "Minnie's Dress",
    //         'A Magical Flying Carpet'
    //       ],
    //       points: 20,
    //       answer: 0,
    //       displayAnswer: 'A) A turban'
    //     },
    //     {
    //       id: '27',
    //       startTime: 45 * 60 + 46,
    //       type: 'results',
    //       resultsFor: '26'
    //     },
    //     {
    //       id: '28',
    //       startTime: 48 * 60 + 42,
    //       type: 'numberCurve',
    //       pause: true,
    //       question:
    //         'How Many Hearts Does Catsworth Have At The End Of The Challenge?',
    //       answer: 1,
    //       displayAnswer: '1 heart',
    //       points: 10,
    //       stepAmount: 1,
    //       stepDrop: 5
    //     },
    //     {
    //       id: '29',
    //       startTime: 50 * 60 + 4,
    //       type: 'results',
    //       resultsFor: '28'
    //     },
    //     {
    //       id: '30',
    //       startTime: 51 * 60 + 41,
    //       type: 'multiple',
    //       pause: true,
    //       question:
    //         "Sonic & Knuckles: What Was Written Under Knuckes's Extra Lives Counter?",
    //       choices: ['Knux', 'K T E', 'Lives', 'Knuckles'],
    //       points: 10,
    //       answer: 1,
    //       displayAnswer: 'B) K T E'
    //     },
    //     {
    //       id: '31',
    //       startTime: 51 * 60 + 46,
    //       type: 'results',
    //       resultsFor: '30'
    //     },
    //     {
    //       id: '32',
    //       startTime: 52 * 60 + 34,
    //       endTime: 54 * 60 + 34,
    //       type: 'order',
    //       pause: false,
    //       question: 'Guess The Order The Players Will Finish In (By Score)',
    //       choices: [
    //         'Psychedlic Eyeball',
    //         'Catsworth',
    //         'Proton Jon',
    //         'Skippy Granola'
    //       ],
    //       points: 40,
    //       answer: 3124,
    //       displayAnswer: '3124'
    //     },
    //     {
    //       id: '33',
    //       startTime: 57 * 60 + 35,
    //       type: 'results',
    //       resultsFor: '32'
    //     },
    //     {
    //       id: '33',
    //       startTime: 57 * 60 + 50,
    //       type: 'results',
    //       resultsFor: '1'
    //     },
    //     {
    //       id: '34',
    //       startTime: 58 * 60 + 50,
    //       type: 'finalResults',
    //       resultsFor: '1'
    //     }
    //   ]
    // }
}
